export const services = [
  {
    id: 'diagnostic-review',
    title: 'Diagnostic Bundle Review',
    price: 495,
    duration: 'Case Clarification',
    description: 'Comprehensive review of your diagnostic materials and lab results with expert analysis and clarification.',
    features: [
      'Complete diagnostic material review',
      'Lab result analysis',
      'Written summary report',
      'Clarification of findings',
      'Up to 2 follow-up questions answered via email'
    ],
    icon: 'FileText',
    paymentOption: null,
    note: null
  },
  {
    id: 'advocacy-launch',
    title: 'Advocacy Launch Session',
    subtitle: 'The Action Plan Intensive',
    price: 1197,
    duration: '30 Minutes',
    description: 'A focused 30-minute session where we translate your complex history into a powerful, actionable strategy. You\'ll receive a customized doctor conversation script, a prioritized testing roadmap, and the confidence to lead your next appointment.',
    features: [
      'Personalized 30-minute video consultation',
      'Customized doctor conversation script',
      'Prioritized testing roadmap',
      'Advocacy training document',
      'Post-consultation action plan'
    ],
    icon: 'Video',
    featured: true,
    paymentOption: null,
    note: 'One-time package; no additional calls or follow-ups beyond one clarification email within 14 days.'
  },
  {
    id: 'deep-dive',
    title: 'Deep Dive Consultation',
    price: 1797,
    duration: '2 Hours',
    description: 'A comprehensive 2-hour consultation with thorough investigation, advocacy strategy, and personalized care navigation. Ideal for complex cases requiring deep analysis.',
    features: [
      'Extended 2-hour consultation',
      'Complete medical history review',
      'Detailed medical script creation',
      'Treatment options discussion',
      'One follow-up email within 14 days'
    ],
    icon: 'Heart',
    paymentOption: null,
    note: 'This is a one-time package and does not include ongoing advocacy.'
  }
];

export const membershipPlans = [
  {
    id: 'navigator',
    name: 'Navigator',
    price: 179,
    interval: 'month',
    tagline: 'Your Safety Net',
    description: 'The "Graduate" who wants a safety net. Perfect after a diagnostic package or for those who need periodic expert guidance.',
    targetClient: 'Perfect after a diagnostic package or for those who need periodic expert guidance.',
    features: [
      'Quarterly 15-minute strategy call (4 calls per year)',
      'Email access (response within 3 business days)',
      'Annual comprehensive record review',
      '20% discount on all à la carte services'
    ],
    footnote: 'Additional services available à la carte. Members receive discounts as shown.'
  },
  {
    id: 'advocate',
    name: 'Advocate',
    price: 399,
    interval: 'month',
    tagline: 'Your Proactive Health Partner',
    description: 'Actively managing a chronic/complex condition (e.g., PCOS, Long COVID, autoimmune). For when your health needs consistent strategy and monthly support.',
    targetClient: 'Actively managing a chronic/complex condition (e.g., PCOS, Long COVID, autoimmune).',
    featured: true,
    features: [
      'Monthly 30-minute strategy call (12 calls per year)',
      'Email access (response within 2 business days)',
      'Appointment preparation for up to 4 medical visits per year',
      '30% discount on all à la carte services'
    ],
    footnote: 'Additional services available à la carte. Members receive discounts as shown.'
  },
  {
    id: 'concierge',
    name: 'Concierge',
    price: 799,
    interval: 'month',
    tagline: 'Complete Health Leadership',
    description: 'High-needs individuals or families requiring comprehensive, hands-on navigation. Delegate the logistical and strategic burden of managing complex care.',
    targetClient: 'High-needs individuals or families requiring comprehensive, hands-on navigation.',
    features: [
      'Monthly 60-minute strategy call (12 calls per year)',
      'Email/chat access (response within 48 hours)',
      'Appointment preparation & debrief for up to 8 medical visits per year',
      'One annual comprehensive record review',
      '40% discount on all à la carte services'
    ],
    footnote: 'Additional services available à la carte. Members receive discounts as shown.'
  }
];


export const aLaCarteServices = [
  {
    id: 'medical-script',
    title: 'Medical Script Writing',
    price: 175,
    description: 'Custom conversation script for your upcoming medical appointment.',
    stage: 'before'
  },
  {
    id: 'appointment-prep',
    title: 'Appointment Preparation',
    price: 250,
    description: 'Pre-visit preparation including question list and presentation tips.',
    stage: 'before',
    details: {
      included: [
        'One-page bulleted list of your top questions and goals',
        'Brief tips on how to present your concerns',
        'Delivered via secure message at least 48 hours before your visit',
        'Maximum 45 minutes of preparation work'
      ],
      notIncluded: [
        'In-depth research',
        'Attending the appointment',
        'Post-visit follow-up'
      ]
    }
  },
  {
    id: 'record-review',
    title: 'Record Review & Summary',
    price: 400,
    description: 'Comprehensive review and summary of up to 50 pages of medical records.',
    stage: 'before'
  },
  {
    id: 'provider-coordination',
    title: 'Provider Coordination',
    price: 200,
    priceNote: 'per hour · 15-min increments',
    description: 'Direct coordination with your healthcare providers on your behalf.',
    stage: 'during',
    details: {
      included: [
        'Written authorization for a single, clearly defined task',
        'Time tracked in 15-minute increments (minimum 30 minutes)',
        'Summary of what was discussed or accomplished',
        'Additional time available for purchase'
      ],
      notIncluded: [
        'Ongoing case management across multiple providers',
        'Medical decision-making'
      ]
    }
  },
  {
    id: 'strategy-session',
    title: '30-Min Strategy Session',
    price: 300,
    description: 'Focused consultation to address specific concerns or develop action plans.',
    stage: 'during'
  },
  {
    id: 'follow-up-call',
    title: '15-Min Follow-Up Call',
    price: 150,
    description: 'Quick check-in or clarification call with your medical advocate.',
    stage: 'after'
  },
  {
    id: 'visit-support-package',
    title: 'Visit Support Package',
    price: 350,
    description: 'Complete visit support bundle at a discounted rate.',
    isBundle: true,
    stage: 'bundle',
    bundleIncludes: [
      'Appointment Preparation ($250 value)',
      '15-min Follow-Up Call ($150 value)',
      '30 minutes of Provider Coordination ($100 value)'
    ],
    savings: '$150 savings'
  }
];


export const articles = [
  // ========================================
  // HEALTH EQUITY & PATIENT ADVOCACY SERIES
  // ========================================
  {
    id: 101,
    title: "Why Women of Color Should Seek Second Opinions for Autoimmune Diseases",
    subtitle: "Your Intuition Is Real. Your Symptoms Are Valid.",
    excerpt: "For women of color navigating symptoms of autoimmune diseases, the path to diagnosis is often fraught with delays and dismissal. A second opinion isn't distrust—it's powerful advocacy.",
    category: 'Patient Advocacy',
    topicCategory: "Women's Health",
    readTime: '8 min',
    image: 'https://static.prod-images.emergentagent.com/jobs/4ecbab6d-133a-4934-a1b6-0486cb2400f1/images/0e6d6ddb550f05fcc6085b6b1c6aafe68843cdd9106c7a3211b24420a8b43a8c.png',
    date: '2026-02-02',
    author: 'Dr. Lakia Stewart, DNP, FNP-C, WHNP-BC',
    authorRole: 'Chief Medical Officer, CADENCE Medical Consulting, LLC',
    featured: true,
    isSlideshow: true,
    slides: [
      {
        title: "Your Intuition Is Real",
        content: "For women of color navigating symptoms of autoimmune diseases like lupus, MS, or rheumatoid arthritis, the path to a correct diagnosis is often fraught with delays and dismissal.",
        highlight: "Systemic bias in healthcare can lead to devastating gaps in care.",
        image: "https://static.prod-images.emergentagent.com/jobs/4ecbab6d-133a-4934-a1b6-0486cb2400f1/images/0e6d6ddb550f05fcc6085b6b1c6aafe68843cdd9106c7a3211b24420a8b43a8c.png",
        icon: "Heart"
      },
      {
        title: "The Diagnosis Delay",
        content: "The numbers tell a troubling story:",
        cards: [
          { title: "4+ Doctors", stat: "Average", desc: "before correct diagnosis" },
          { title: "3+ Years", stat: "Average", desc: "of symptoms before answers" },
          { 
            title: "2.5x", 
            stat: "More Likely", 
            desc: "for Black patients to be dismissed",
            comparison: {
              baseline: { label: "White", value: "1x" },
              highlight: { label: "Black", value: "2.5x", percent: 100 }
            }
          },
          { title: "Higher", stat: "Mortality", desc: "for Black & Hispanic women with lupus" }
        ],
        icon: "AlertTriangle"
      },
      {
        title: "Why The Disparity?",
        content: "Multiple factors contribute to delayed diagnoses in women of color:",
        bullets: [
          "Implicit bias in symptom interpretation",
          "Research historically excluded diverse populations",
          "Symptoms may present differently across ethnicities",
          "Pain and fatigue more likely to be dismissed as 'psychological'",
          "Less access to specialists in underserved communities"
        ],
        image: "https://static.prod-images.emergentagent.com/jobs/4ecbab6d-133a-4934-a1b6-0486cb2400f1/images/de86df1758d60e8f119bc5fd5e8860b15508aa9e2e29d09b9fcc6ae6d0b72b1b.png",
        icon: "Activity"
      },
      {
        title: "The Real Impact",
        content: "Delayed diagnosis isn't just frustrating—it's dangerous:",
        bullets: [
          "Disease progression without treatment",
          "Irreversible organ damage (especially in lupus)",
          "Years of unnecessary suffering",
          "Financial burden from repeated, inconclusive visits",
          "Psychological toll of not being believed"
        ],
        highlight: "Early diagnosis saves lives. You deserve timely answers.",
        icon: "Shield"
      },
      {
        title: "Lupus: A Case Study in Disparity",
        content: "Lupus affects 1.5 million Americans, but the burden is unequal:",
        donutChart: {
          segments: [
            { label: "Black Women", value: 40 },
            { label: "Hispanic Women", value: 25 },
            { label: "Asian Women", value: 15 },
            { label: "White Women", value: 20 }
          ],
          centerValue: "90%",
          centerLabel: "Women"
        },
        highlight: "Black women are 2-3x more likely to develop lupus and face higher mortality rates.",
        icon: "FileText"
      },
      {
        title: "What Is a Second Opinion?",
        content: "A second opinion means having another qualified doctor review your case independently.",
        bullets: [
          "It's a medical RIGHT, not a privilege",
          "It's NOT a sign of distrust",
          "It CAN validate your experience",
          "It OFTEN clarifies complex diagnoses",
          "It OPENS doors to effective treatment"
        ],
        highlight: "A good doctor will never be offended by a second opinion request.",
        icon: "UserCheck"
      },
      {
        title: "When to Seek a Second Opinion",
        content: "Consider getting another perspective if:",
        bullets: [
          "Your symptoms persist despite 'normal' test results",
          "You've been told it's 'just stress' or 'anxiety'",
          "You're facing a major diagnosis or surgery",
          "Your treatment isn't working",
          "You feel dismissed or unheard",
          "Something just doesn't feel right"
        ],
        image: "https://static.prod-images.emergentagent.com/jobs/4ecbab6d-133a-4934-a1b6-0486cb2400f1/images/af4e0abba456e595df9c7fc9a87de63ea39cb7a78a86178414f2b9e0f7078369.png",
        icon: "Search"
      },
      {
        title: "How to Get a Second Opinion",
        content: "Practical steps to take:",
        bullets: [
          "Request copies of ALL your medical records",
          "Research specialists who focus on your condition",
          "Seek providers at academic medical centers",
          "Look for doctors with diverse patient populations",
          "Consider telehealth for access to distant specialists",
          "Work with a patient advocate if needed"
        ],
        icon: "Clipboard"
      },
      {
        title: "Prepare Like a CEO",
        content: "You are the CEO of your health. Before your second opinion:",
        bullets: [
          "Create a symptom timeline with dates and severity",
          "List all previous tests and their results",
          "Document what treatments you've tried",
          "Write down your top 3-5 questions",
          "Bring a trusted person for support"
        ],
        image: "https://static.prod-images.emergentagent.com/jobs/4ecbab6d-133a-4934-a1b6-0486cb2400f1/images/67e732b597c5405810e450be848f1dbe9bdf0d0a9e1d1987010d4f4e741a557a.png",
        icon: "FileText"
      },
      {
        title: "Questions to Ask",
        content: "Bring these to your second opinion consultation:",
        bullets: [
          "Based on my records, what do you think is happening?",
          "Do you agree with my current diagnosis?",
          "What additional tests would you recommend?",
          "Are there other conditions we should rule out?",
          "What treatment approach would you suggest?",
          "What's the timeline for seeing improvement?"
        ],
        icon: "MessageCircle"
      },
      {
        title: "Your Advocacy Toolkit",
        content: "Resources to support your journey:",
        columns: [
          {
            header: "Organizations",
            items: ["Lupus Foundation of America", "Arthritis Foundation", "National MS Society", "American Autoimmune Related Diseases Association"]
          },
          {
            header: "Actions",
            items: ["Join support groups", "Document everything", "Trust your instincts", "Don't give up"]
          }
        ],
        icon: "Users"
      },
      {
        title: "You Deserve Answers",
        content: "A second opinion is not a sign of distrust—it's a powerful tool for advocacy.",
        highlight: "It can validate your experience, clarify a complex diagnosis, and open doors to more effective treatment plans.",
        bullets: [
          "Your symptoms are real",
          "Your pain is valid",
          "You deserve to be heard",
          "You have the right to answers"
        ],
        cta: true,
        icon: "Heart"
      }
    ]
  },
  {
    id: 102,
    title: "How to Advocate for Yourself in a Biased Healthcare System",
    subtitle: "A Practical Guide to Getting the Care You Deserve",
    excerpt: "Navigating healthcare when your concerns are dismissed requires strategy. Here's your step-by-step guide to preparing, communicating, and advocating effectively.",
    category: 'Patient Advocacy',
    topicCategory: 'Appointment Preparation',
    readTime: '10 min',
    image: 'https://static.prod-images.emergentagent.com/jobs/4ecbab6d-133a-4934-a1b6-0486cb2400f1/images/2ca12a712d95ae7f91073e7bda6e7161747fdfc9451557f86535d6d60e67c243.png',
    date: '2026-02-02',
    author: 'Dr. Lakia Stewart, DNP, FNP-C, WHNP-BC',
    authorRole: 'Chief Medical Officer, CADENCE Medical Consulting, LLC',
    featured: false,
    isSlideshow: true,
    slides: [
      {
        title: "The Challenge We Face",
        content: "Navigating the healthcare system when you're not feeling your best is challenging. For marginalized groups—including people of color, women, and LGBTQ+ individuals—systemic bias makes it feel impossible.",
        highlight: "Your symptoms might be downplayed, your pain questioned, and your concerns rushed. But your health is non-negotiable.",
        image: "https://static.prod-images.emergentagent.com/jobs/4ecbab6d-133a-4934-a1b6-0486cb2400f1/images/0e6d6ddb550f05fcc6085b6b1c6aafe68843cdd9106c7a3211b24420a8b43a8c.png",
        icon: "AlertTriangle"
      },
      {
        title: "Step 1: Prepare Like a CEO",
        content: "You are the CEO of your health. Before any appointment, create a dedicated 'health file.'",
        highlight: "This preparation shifts the dynamic. You're not describing a vague feeling—you're presenting data.",
        image: "https://static.prod-images.emergentagent.com/jobs/4ecbab6d-133a-4934-a1b6-0486cb2400f1/images/67e732b597c5405810e450be848f1dbe9bdf0d0a9e1d1987010d4f4e741a557a.png",
        icon: "FileText"
      },
      {
        title: "Log Your Symptoms",
        content: "Use a notebook or app to record:",
        bullets: [
          "Symptoms with dates and times",
          "Severity on a 1-10 scale",
          "Potential triggers you've noticed",
          "How symptoms impact daily activities",
          "What makes them better or worse"
        ],
        highlight: "Patterns often reveal underlying conditions that individual symptoms miss.",
        icon: "Edit"
      },
      {
        title: "Prepare Your Questions",
        content: "Write down your top 3-5 questions and prioritize them:",
        bullets: [
          "What patterns do you see in my symptoms over time?",
          "What conditions could explain ALL my symptoms together?",
          "What tests would rule out the most serious possibilities?",
          "What's the next step if this treatment doesn't work?",
          "Can you explain why you believe this is/isn't [specific condition]?"
        ],
        icon: "HelpCircle"
      },
      {
        title: "Gather Your Records",
        content: "Bring copies of:",
        bullets: [
          "Past test results and lab work",
          "Complete medication list (including supplements)",
          "Previous diagnoses and treatments tried",
          "Notes from other providers",
          "Your symptom log"
        ],
        highlight: "This prevents starting from scratch at every appointment.",
        icon: "Folder"
      },
      {
        title: "Step 2: Communicate with Clarity",
        content: "During the visit, use clear, direct communication. Don't minimize your symptoms or apologize for taking their time.",
        highlight: "You deserve the same thorough attention as any other patient.",
        icon: "MessageSquare"
      },
      {
        title: "The 'Repeat Back' Method",
        content: "After the doctor explains something, say:",
        highlight: "'Let me make sure I understand. You're saying that…'",
        bullets: [
          "Ensures you understood correctly",
          "Shows you're engaged and informed",
          "Creates opportunity for clarification",
          "Documents the conversation implicitly"
        ],
        icon: "RefreshCw"
      },
      {
        title: "The BRIEF Script",
        content: "If you feel dismissed, use this structure:",
        columns: [
          {
            header: "The Framework",
            items: ["Background: 'For the past three months, I've had…'", "Repeat: 'As I've mentioned, the fatigue is severe.'", "Impact: 'This is preventing me from working.'", "Expectation: 'I need us to investigate further.'", "Follow-up: 'What's the next diagnostic step?'"]
          }
        ],
        icon: "Layout"
      },
      {
        title: "Ask for Documentation",
        content: "This is one of the most powerful tools you have:",
        highlight: "'Please note in my chart that I requested [X test or referral] and you declined.'",
        bullets: [
          "Formalizes the decision in your record",
          "Often prompts reconsideration",
          "Creates accountability",
          "Protects you legally"
        ],
        icon: "FileText"
      },
      {
        title: "Step 3: Build Your Village",
        content: "Self-advocacy doesn't mean going it alone.",
        image: "https://static.prod-images.emergentagent.com/jobs/4ecbab6d-133a-4934-a1b6-0486cb2400f1/images/af4e0abba456e595df9c7fc9a87de63ea39cb7a78a86178414f2b9e0f7078369.png",
        icon: "Users"
      },
      {
        title: "Bring an Ally",
        content: "A trusted friend or family member can:",
        bullets: [
          "Take notes so you can focus on the conversation",
          "Ask questions you might forget",
          "Witness what's said (or not said)",
          "Provide moral support",
          "Help you process afterward"
        ],
        icon: "UserPlus"
      },
      {
        title: "Seek Multiple Opinions",
        content: "If you feel unheard, get another perspective.",
        bullets: [
          "A good doctor will NOT be offended",
          "It's your RIGHT, not a privilege",
          "Different specialists see different patterns",
          "Academic medical centers often have broader expertise",
          "Telehealth expands your options geographically"
        ],
        highlight: "A second (or third) opinion can save your life.",
        icon: "Search"
      },
      {
        title: "Trust Your Gut",
        content: "You are the expert on your own body.",
        highlight: "If something feels wrong, it probably is. Persist.",
        bullets: [
          "Don't let anyone gaslight your experience",
          "Your symptoms are real",
          "You know when something isn't right",
          "Keep seeking answers until you find them"
        ],
        icon: "Heart"
      },
      {
        title: "Red Flags to Watch For",
        content: "Consider seeking another provider if:",
        bullets: [
          "Your concerns are dismissed without investigation",
          "You're told it's 'just stress' repeatedly",
          "The provider seems rushed or distracted",
          "You feel judged or not believed",
          "Tests are refused without explanation",
          "You leave feeling worse than when you arrived"
        ],
        icon: "AlertCircle"
      },
      {
        title: "You Deserve Better",
        content: "Advocacy is an ongoing practice, not a one-time event. It's tiring, but your life and well-being are worth the effort.",
        highlight: "By preparing, communicating strategically, and assembling support, you can navigate a biased system and get the care you deserve.",
        cta: true,
        icon: "Award"
      }
    ]
  },
  {
    id: 103,
    title: "Signs Your Symptoms Are Being Dismissed",
    subtitle: "How to Recognize Medical Gaslighting",
    excerpt: "Learn the warning signs that your healthcare concerns aren't being taken seriously—and what to do about it.",
    category: 'Patient Advocacy',
    topicCategory: 'Adult Health',
    readTime: '7 min',
    image: 'https://static.prod-images.emergentagent.com/jobs/4ecbab6d-133a-4934-a1b6-0486cb2400f1/images/0e6d6ddb550f05fcc6085b6b1c6aafe68843cdd9106c7a3211b24420a8b43a8c.png',
    date: '2026-02-02',
    author: 'Dr. Lakia Stewart, DNP, FNP-C, WHNP-BC',
    authorRole: 'Chief Medical Officer, CADENCE Medical Consulting, LLC',
    featured: false,
    isSlideshow: true,
    slides: [
      {
        title: "What Is Medical Gaslighting?",
        content: "Medical gaslighting occurs when healthcare providers dismiss, minimize, or blame patients for their symptoms.",
        highlight: "It's not just bad bedside manner—it can lead to delayed diagnoses, worsening conditions, and psychological harm.",
        icon: "AlertTriangle"
      },
      {
        title: "Who's Most Affected?",
        content: "Research shows these groups face higher rates of dismissal:",
        cards: [
          { title: "Women", stat: "2x", desc: "more likely to be dismissed" },
          { title: "Black Patients", stat: "2.5x", desc: "pain underestimated" },
          { title: "Chronic Illness", stat: "Often", desc: "labeled 'difficult'" },
          { title: "Mental Health Hx", stat: "Higher", desc: "physical symptoms dismissed" }
        ],
        icon: "Users"
      },
      {
        title: "Red Flag #1: 'It's Just Stress'",
        content: "While stress can cause symptoms, this phrase is often used to avoid investigation.",
        highlight: "If you hear this repeatedly without testing, push back.",
        bullets: [
          "Ask: 'What specific tests would rule out other causes?'",
          "Request documentation of why they believe it's stress",
          "Seek a second opinion if dismissed"
        ],
        icon: "XCircle"
      },
      {
        title: "Red Flag #2: 'Your Labs Are Normal'",
        content: "Normal labs don't mean normal YOU.",
        bullets: [
          "Reference ranges are population averages",
          "Your 'normal' may be different",
          "Trends over time matter more than single results",
          "Some conditions don't show in standard panels",
          "Ask for comprehensive testing, not just basics"
        ],
        icon: "FileText"
      },
      {
        title: "Red Flag #3: Rushed Appointments",
        content: "Warning signs of a rushed provider:",
        bullets: [
          "Interrupts you within seconds of speaking",
          "Looks at computer more than you",
          "Dismisses your prepared notes",
          "Hand on doorknob while you're still talking",
          "Prescribes without examining you"
        ],
        icon: "Clock"
      },
      {
        title: "Red Flag #4: Blame Shifting",
        content: "Watch for these phrases:",
        bullets: [
          "'Have you tried losing weight?'",
          "'You're too young for that'",
          "'You seem anxious'",
          "'Some people are just tired'",
          "'Maybe you're just sensitive to pain'"
        ],
        highlight: "Your symptoms exist regardless of your weight, age, or mental state.",
        icon: "MessageCircle"
      },
      {
        title: "Red Flag #5: Refusing Tests",
        content: "If a provider refuses testing without explanation:",
        bullets: [
          "Ask: 'Why specifically are you not ordering this?'",
          "Request: 'Please document this refusal in my chart'",
          "Inquire: 'What would need to happen for you to order it?'",
          "Consider: Getting a second opinion"
        ],
        icon: "Search"
      },
      {
        title: "The Psychological Toll",
        content: "Being dismissed takes a real emotional toll:",
        bullets: [
          "Self-doubt about your own experiences",
          "Anxiety before appointments",
          "Reluctance to seek care",
          "Depression from feeling unheard",
          "Isolation and frustration"
        ],
        highlight: "Your feelings are valid. This is not your fault.",
        icon: "Heart"
      },
      {
        title: "What You Can Do",
        content: "Protect yourself with these strategies:",
        bullets: [
          "Document everything in writing",
          "Bring a witness to appointments",
          "Ask for chart notes to be read back",
          "Request referrals to specialists",
          "File complaints when appropriate",
          "Find providers who listen"
        ],
        icon: "Shield"
      },
      {
        title: "You Deserve to Be Heard",
        content: "Remember: persistence is not being 'difficult'—it's necessary self-advocacy.",
        highlight: "Your symptoms are real. Your concerns are valid. Keep pushing until you get answers.",
        cta: true,
        icon: "Award"
      }
    ]
  },
  {
    id: 104,
    title: "How to Request Your Medical Records",
    subtitle: "A Step-by-Step Guide to Accessing Your Health Information",
    excerpt: "Your medical records belong to YOU. Here's exactly how to request, organize, and use them for better care.",
    category: 'Patient Advocacy',
    topicCategory: 'Appointment Preparation',
    readTime: '6 min',
    image: 'https://static.prod-images.emergentagent.com/jobs/4ecbab6d-133a-4934-a1b6-0486cb2400f1/images/67e732b597c5405810e450be848f1dbe9bdf0d0a9e1d1987010d4f4e741a557a.png',
    date: '2026-02-02',
    author: 'CADENCE Medical Consulting, LLC',
    authorRole: 'Patient Advocacy Team',
    featured: false,
    isSlideshow: true,
    slides: [
      {
        title: "Your Records, Your Right",
        content: "Under HIPAA, you have the legal right to access all of your medical records.",
        highlight: "Providers must respond within 30 days of your request.",
        bullets: [
          "This includes: doctor's notes, test results, imaging, prescriptions",
          "You can get paper copies or electronic access",
          "Providers can charge reasonable fees for copies",
          "They CANNOT refuse because of unpaid bills"
        ],
        icon: "Shield"
      },
      {
        title: "Why Request Your Records?",
        content: "Having your complete medical history helps you:",
        bullets: [
          "See the full picture of your health over time",
          "Share accurate information with new providers",
          "Prepare for second opinion consultations",
          "Catch errors or missing information",
          "Understand what tests you've had (and haven't)",
          "Take control of your healthcare journey"
        ],
        icon: "FileText"
      },
      {
        title: "Step 1: Identify All Providers",
        content: "Make a list of everyone who has your records:",
        bullets: [
          "Primary care physicians (past and current)",
          "All specialists you've seen",
          "Hospitals and urgent care visits",
          "Labs (Quest, LabCorp, hospital labs)",
          "Imaging centers (X-ray, MRI, CT facilities)",
          "Physical therapists, mental health providers"
        ],
        icon: "Users"
      },
      {
        title: "Step 2: Contact Medical Records",
        content: "For each provider:",
        bullets: [
          "Call the office and ask for Medical Records department",
          "Many offices have online patient portals",
          "Request their authorization/release form",
          "Ask about fees and delivery options",
          "Specify the date range you need"
        ],
        icon: "Phone"
      },
      {
        title: "Step 3: Complete the Form",
        content: "When filling out the authorization:",
        bullets: [
          "Specify ALL records (not just a summary)",
          "Include date range (or 'all available records')",
          "Request office notes, lab results, and imaging",
          "Choose electronic delivery when possible (often free)",
          "Sign and date the form",
          "Keep a copy for yourself"
        ],
        icon: "Edit"
      },
      {
        title: "Step 4: Follow Up",
        content: "Don't just wait—be proactive:",
        bullets: [
          "Note when you submitted each request",
          "Call after 2 weeks if no response",
          "Document all interactions",
          "Escalate to office manager if needed",
          "File a HIPAA complaint if rights are violated"
        ],
        highlight: "Persistence pays off. They're required to respond within 30 days.",
        icon: "Clock"
      },
      {
        title: "Step 5: Organize Your Records",
        content: "Create a master health file:",
        bullets: [
          "Digital folder (cloud storage recommended)",
          "Organize by provider or by date",
          "Create a summary sheet of key diagnoses",
          "List all medications (current and past)",
          "Track test results over time",
          "Update regularly"
        ],
        icon: "Folder"
      },
      {
        title: "Pro Tips",
        content: "Make the most of your records:",
        bullets: [
          "Request records BEFORE appointments",
          "Bring printed copies to new providers",
          "Review for errors and request corrections",
          "Note which tests you've had to avoid repeats",
          "Share with family members if appropriate"
        ],
        cta: true,
        icon: "Award"
      }
    ]
  },
  {
    id: 105,
    title: "Preparing for a Second Opinion Consultation",
    subtitle: "How to Make the Most of Your Second Opinion",
    excerpt: "A second opinion is only as valuable as your preparation. Here's how to get the most out of this important appointment.",
    category: 'Patient Advocacy',
    topicCategory: 'Appointment Preparation',
    readTime: '7 min',
    image: 'https://static.prod-images.emergentagent.com/jobs/4ecbab6d-133a-4934-a1b6-0486cb2400f1/images/af4e0abba456e595df9c7fc9a87de63ea39cb7a78a86178414f2b9e0f7078369.png',
    date: '2026-02-02',
    author: 'Dr. Lakia Stewart, DNP, FNP-C, WHNP-BC',
    authorRole: 'Chief Medical Officer, CADENCE Medical Consulting, LLC',
    featured: false,
    isSlideshow: true,
    slides: [
      {
        title: "You've Made a Powerful Choice",
        content: "Seeking a second opinion shows you're taking control of your health.",
        highlight: "Now let's make sure you get maximum value from this appointment.",
        icon: "Award"
      },
      {
        title: "2-4 Weeks Before",
        content: "Start preparing early:",
        bullets: [
          "Request ALL medical records (see our guide)",
          "Compile test results, imaging reports, biopsy reports",
          "Get actual imaging CDs, not just reports",
          "Write your medical timeline",
          "List questions you want answered"
        ],
        icon: "Calendar"
      },
      {
        title: "Create Your Medical Timeline",
        content: "Document your health journey chronologically:",
        bullets: [
          "When symptoms first started",
          "Major health events and dates",
          "Diagnoses received (with dates)",
          "Treatments tried and results",
          "Tests performed and outcomes",
          "Current symptoms and severity"
        ],
        icon: "Clock"
      },
      {
        title: "Prepare Your Questions",
        content: "Prioritize your top questions:",
        bullets: [
          "Do you agree with my current diagnosis?",
          "What else could be causing my symptoms?",
          "What additional testing would you recommend?",
          "What treatment approach would you suggest?",
          "What's the expected timeline for improvement?",
          "What happens if treatment doesn't work?"
        ],
        icon: "HelpCircle"
      },
      {
        title: "1 Week Before",
        content: "Finalize your preparation:",
        bullets: [
          "Confirm appointment time and location",
          "Verify what records they've received",
          "Send any missing documents",
          "Prepare copies of everything to bring",
          "Arrange transportation if needed"
        ],
        icon: "CheckCircle"
      },
      {
        title: "The Day Before",
        content: "Set yourself up for success:",
        bullets: [
          "Organize your documents in a folder",
          "Review your questions one more time",
          "Confirm your support person is coming",
          "Get good rest (if possible)",
          "Plan to arrive 15-20 minutes early"
        ],
        icon: "Folder"
      },
      {
        title: "What to Bring",
        content: "Your second opinion toolkit:",
        bullets: [
          "Government ID and insurance cards",
          "Complete medical records (organized)",
          "Imaging CDs (X-rays, MRIs, CTs)",
          "List of current medications and supplements",
          "Your medical timeline document",
          "List of prioritized questions",
          "Notebook and pen for notes"
        ],
        icon: "Briefcase"
      },
      {
        title: "During the Appointment",
        content: "Make the most of your time:",
        bullets: [
          "Be honest and thorough",
          "Share your complete history",
          "Don't minimize symptoms",
          "Ask ALL your prepared questions",
          "Take notes or record (with permission)",
          "Ask for clarification if needed"
        ],
        icon: "MessageCircle"
      },
      {
        title: "After the Appointment",
        content: "Important next steps:",
        bullets: [
          "Request a copy of their notes/report",
          "Review their recommendations carefully",
          "Compare with your original diagnosis/plan",
          "Discuss findings with your primary provider",
          "Make informed decisions about next steps"
        ],
        icon: "FileText"
      },
      {
        title: "Trust the Process",
        content: "Remember why you're here:",
        highlight: "You deserve clear answers and the best possible care plan. A thorough second opinion brings you closer to both.",
        cta: true,
        icon: "Heart"
      }
    ]
  },
  // ========================================
  // EXISTING ARTICLES BELOW
  // ========================================
  {
    id: 5,
    title: "What's Going On With My Period?",
    subtitle: "Understanding Abnormal Uterine Bleeding",
    excerpt: 'A visual guide to understanding irregular periods, heavy bleeding, and when to seek medical evaluation.',
    category: 'Hard-to-Diagnose Conditions',
    topicCategory: "Women's Health",
    readTime: '6 min',
    image: 'https://images.unsplash.com/photo-1631815588090-d4bfec5b1ccb?w=800',
    date: '2025-10-04',
    author: 'Dr. Lakia Stewart, DNP, FNP-C, WHNP-BC',
    authorRole: 'Chief Medical Officer, CADENCE Medical Consulting, LLC',
    featured: true,
    isSlideshow: true,
    slides: [
      {
        title: "You're Not Alone",
        content: "Abnormal Uterine Bleeding (AUB) affects up to 30% of women during their reproductive years.",
        highlight: "Yet many suffer in silence, unsure if their symptoms are 'normal'.",
        icon: "Heart"
      },
      {
        title: "What's 'Normal' Bleeding?",
        content: "A typical menstrual cycle:",
        bullets: [
          "Occurs every 21-35 days",
          "Lasts 2-7 days", 
          "Blood loss of 5-80 mL (1-6 tablespoons)",
          "Relatively consistent month to month"
        ],
        icon: "Calendar"
      },
      {
        title: "When to Be Concerned",
        content: "Seek evaluation if you experience:",
        bullets: [
          "Bleeding between periods or after menopause",
          "Periods lasting longer than 7 days",
          "Soaking through a pad/tampon every hour",
          "Blood clots larger than a quarter",
          "Severe pain with periods",
          "Signs of anemia (fatigue, dizziness)"
        ],
        highlight: "Your pain is real. Don't minimize your symptoms.",
        icon: "AlertTriangle"
      },
      {
        title: "The PALM-COEIN System",
        content: "Doctors classify AUB causes into two categories:",
        columns: [
          {
            header: "PALM (Structural)",
            items: ["Polyps", "Adenomyosis", "Leiomyomas (Fibroids)", "Malignancy"]
          },
          {
            header: "COEIN (Non-Structural)",
            items: ["Coagulopathy", "Ovulatory dysfunction", "Endometrial issues", "Iatrogenic", "Not yet classified"]
          }
        ],
        icon: "FileText"
      },
      {
        title: "Common Conditions",
        content: "Several conditions can cause abnormal bleeding:",
        cards: [
          { title: "Fibroids", stat: "80%", desc: "of women by age 50", showPie: true, pieColor: '#4A0E4E' },
          { title: "Adenomyosis", stat: "28%", desc: "of women affected", showPie: true, pieColor: '#D4AF37' },
          { title: "PCOS", stat: "9%", desc: "of reproductive-age women", showPie: true, pieColor: '#7C3AED' },
          { title: "Endometriosis", stat: "10%", desc: "of women worldwide", showPie: true, pieColor: '#059669' }
        ],
        icon: "Activity"
      },
      {
        title: "Getting Answers",
        content: "Your provider may recommend:",
        bullets: [
          "Complete medical history & pelvic exam",
          "Blood tests (CBC, thyroid, hormones)",
          "Transvaginal ultrasound",
          "Endometrial biopsy if indicated",
          "Hysteroscopy for direct visualization"
        ],
        highlight: "Demand complete evaluation. Partial testing misses diagnoses.",
        icon: "Search"
      },
      {
        title: "Treatment Options",
        content: "Treatment depends on the cause and your goals:",
        columns: [
          {
            header: "Medical Management",
            items: ["NSAIDs for pain", "Hormonal contraceptives", "Progestin therapy", "Tranexamic acid", "GnRH medications"]
          },
          {
            header: "Procedural Options",
            items: ["Endometrial ablation", "Uterine artery embolization", "Myomectomy", "Hysterectomy (definitive)"]
          }
        ],
        icon: "Pill"
      },
      {
        title: "Questions for Your Provider",
        content: "Bring these to your next appointment:",
        bullets: [
          "What do you think is causing my bleeding?",
          "What tests do you recommend and why?",
          "What are ALL my treatment options?",
          "How will treatment affect my fertility?",
          "What symptoms should prompt me to return sooner?"
        ],
        cta: true,
        icon: "MessageCircle"
      }
    ]
  },
  {
    id: 1,
    title: 'Understanding Lupus: What Your Lab Results Really Mean',
    excerpt: 'Lupus can be challenging to diagnose. Learn how to interpret your ANA test, complement levels, and other key markers with your healthcare provider.',
    category: 'Hard-to-Diagnose Conditions',
    topicCategory: "Women's Health",
    readTime: '8 min',
    image: 'https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=800',
    date: '2025-01-15',
    content: `Systemic lupus erythematosus (SLE) remains one of the most challenging autoimmune conditions to diagnose. Many patients experience years of symptoms before receiving a confirmed diagnosis.

**Key Lab Markers to Discuss:**

1. **ANA (Antinuclear Antibody) Test**: A positive ANA is present in 95% of lupus patients, but it's not diagnostic on its own. Many healthy individuals also test positive.

2. **Anti-dsDNA and Anti-Smith Antibodies**: These are more specific to lupus. If positive, they strongly suggest SLE.

3. **Complement Levels (C3 and C4)**: Low levels often indicate active lupus, as the immune system is consuming these proteins.

**Questions to Ask Your Provider:**

- What is my ANA titer and pattern?
- Have we tested for specific autoantibodies (anti-dsDNA, anti-Smith, anti-cardiolipin)?
- Are my complement levels normal?
- Do my symptoms align with the diagnostic criteria for lupus?
- Should we consider a referral to a rheumatologist?

**When to Seek a Second Opinion:**

If you have persistent symptoms like joint pain, fatigue, rashes, or organ involvement along with positive lab markers, but haven't received clear answers, a second opinion from a lupus specialist can be invaluable.`
  },
  {
    id: 2,
    title: 'Hypothyroidism: Beyond the TSH Test',
    excerpt: 'TSH levels tell only part of the story. Discover what additional thyroid tests you should request and how to advocate for comprehensive evaluation.',
    category: 'Thyroid Health',
    topicCategory: 'Adult Health',
    readTime: '6 min',
    image: 'https://images.unsplash.com/photo-1559757148-5c350d0d3c56?w=800',
    date: '2025-01-10',
    content: `Many patients with hypothyroid symptoms are told their TSH is "normal" and dismissed. But optimal thyroid function requires looking beyond TSH.

**Complete Thyroid Panel Should Include:**

1. **TSH (Thyroid Stimulating Hormone)**: The standard screening test, but not sufficient alone.

2. **Free T4**: The inactive form of thyroid hormone. Low levels indicate your thyroid isn't producing enough hormone.

3. **Free T3**: The active thyroid hormone. Your body must convert T4 to T3, and problems with conversion can cause symptoms even with normal TSH.

4. **Thyroid Antibodies** (TPO and Thyroglobulin): Elevated levels indicate Hashimoto's thyroiditis, an autoimmune cause of hypothyroidism.

5. **Reverse T3**: High levels can indicate conversion problems or chronic stress affecting thyroid function.

**Symptoms to Document:**

- Persistent fatigue despite adequate sleep
- Unexplained weight gain or difficulty losing weight
- Cold intolerance
- Hair loss or thinning
- Dry skin
- Brain fog and memory issues
- Depression or mood changes
- Constipation
- Muscle weakness

**Your Medical Script:**

"Doctor, I'm experiencing [list symptoms]. I understand my TSH is within the reference range, but I'd like to request a complete thyroid panel including Free T4, Free T3, and thyroid antibodies. I'm concerned about subclinical hypothyroidism or conversion issues that TSH alone wouldn't reveal. Can we do these additional tests?"`
  },
  {
    id: 3,
    title: 'Veterans and Women\'s Health: Navigating VA Care',
    excerpt: 'Special considerations for women veterans accessing healthcare through the VA system, including gender-specific services and advocacy tips.',
    category: 'Veterans Care',
    topicCategory: "Women's Health",
    readTime: '7 min',
    image: 'https://images.unsplash.com/photo-1505751172876-fa1923c5c528?w=800',
    date: '2025-01-05',
    content: `Women veterans face unique challenges in accessing appropriate healthcare through the VA system. Here's how to advocate effectively for your needs.

**Understanding Your VA Benefits:**

Women veterans are entitled to comprehensive healthcare including:
- Primary care with women's health focus
- Gynecological care
- Maternity care
- Mental health services
- Military sexual trauma (MST) counseling
- Mammography and cancer screening

**Common Barriers and Solutions:**

**Barrier 1: Limited Gender-Specific Services**
Many VA facilities were historically designed for male veterans. 

*Solution*: Request referrals to community care providers if your VA facility lacks appropriate women's health services. This is your right under the MISSION Act.

**Barrier 2: Lack of Continuity**
Seeing different providers at each visit makes comprehensive care difficult.

*Solution*: Request assignment to a specific primary care provider and women's health specialist. Document all your concerns in writing before appointments.

**Barrier 3: Dismissal of Symptoms**
Women's pain and symptoms are often minimized or attributed to psychological factors.

*Solution*: Keep detailed symptom logs with dates, severity, and impact on daily life. Bring this documentation to every appointment and request it be added to your medical record.

**Your Advocacy Script:**

"I'm a woman veteran and I need access to gender-specific healthcare services. Under the MISSION Act, I'm entitled to community care if these services aren't adequately available at this facility. I request a referral to [specific specialist] in the community. Additionally, I'd like all my concerns documented in my medical record today."

**Resources:**
- VA Women Veterans Hotline: 1-855-829-6636
- Women Veterans Health Care: www.womenshealth.va.gov
- Patient Advocate at your local VA facility`
  },
  {
    id: 4,
    title: 'Preparing for Your Specialist Appointment: A Comprehensive Guide',
    excerpt: 'Maximize your specialist consultation with this step-by-step preparation guide and conversation framework.',
    category: 'Patient Advocacy',
    topicCategory: 'Appointment Preparation',
    readTime: '5 min',
    image: 'https://images.unsplash.com/photo-1551076805-e1869033e561?w=800',
    date: '2025-01-01',
    content: `Getting a referral to a specialist is just the first step. Here's how to make the most of that valuable appointment time.

**Two Weeks Before:**

1. **Gather Your Medical Records**
   - Recent lab results (within 6 months)
   - Imaging reports and actual images if possible
   - List of current medications with dosages
   - Previous specialist reports
   - Family medical history

2. **Create Your Timeline**
   Document when symptoms started, progression, what makes them better or worse, and treatments you've tried.

3. **List Your Questions**
   Write down everything you want to ask, prioritizing the most important.

**The Night Before:**

- Review your symptom timeline
- Pack your medical records folder
- Prepare your medication list
- Bring a notebook and pen
- Consider bringing a support person

**During the Appointment:**

**Opening Statement:**
"Thank you for seeing me today. I've prepared a timeline of my symptoms and brought my recent test results. My main concerns are [list top 3]. I'm hoping to understand [your primary goal for the visit]."

**Key Questions to Ask:**

1. Based on my symptoms and test results, what are the possible diagnoses?
2. What additional testing do you recommend and why?
3. What are my treatment options, including benefits and risks of each?
4. What's the expected timeline for diagnosis/improvement?
5. When should I follow up with you?
6. What symptoms should prompt me to seek immediate care?
7. Are there lifestyle modifications that could help?

**Red Flags - When to Speak Up:**

- The doctor doesn't review your medical records
- Your concerns are dismissed without explanation
- You're not given time to ask questions
- Treatment is prescribed without explaining the diagnosis
- You feel rushed or unheard

**Closing Statement:**
"Before I leave, I want to make sure I understand: [summarize the key points]. Is that correct? When should I schedule my follow-up?"

**After the Appointment:**

- Write down everything discussed while it's fresh
- Request visit notes to be sent to you
- Schedule any recommended tests promptly
- Contact your primary care doctor to keep them updated

**When CADENCE Can Help:**

If you're preparing for a difficult appointment or didn't get the answers you needed, our medical consultants can:
- Review your records before the appointment
- Help you create targeted questions
- Analyze the specialist's recommendations
- Provide guidance on next steps
- Advocate for appropriate follow-up care`
  },
  {
    id: 6,
    title: "Your Hormonal Health Deserves Attention",
    subtitle: "A Guide for Military Women & Spouses",
    excerpt: 'Navigate hormonal health through TRICARE. Learn about PCOS, thyroid issues, and how to advocate for proper testing.',
    category: 'Hormonal Health',
    topicCategory: "Women's Health",
    readTime: '8 min',
    image: 'https://images.unsplash.com/photo-1559757175-0eb30cd8c063?w=800',
    date: '2026-01-28',
    author: 'CADENCE Medical Consulting, LLC',
    authorRole: 'Patient Advocacy & Health Equity Experts',
    isSlideshow: true,
    slides: [
      {
        title: "The Military Healthcare Challenge",
        content: "Frequent relocations disrupt care continuity. Each PCS means starting over.",
        bullets: [
          "New doctors, new referrals, lost medical records",
          "Mission requirements come first",
          "Limited sick call hours conflict with training",
          "Your health shouldn't wait"
        ],
        highlight: "Your symptoms don't pause between duty stations. Neither should your care.",
        icon: "Shield"
      },
      {
        title: "What Is Hirsutism?",
        content: "Excess coarse, dark hair in male-pattern areas. It's not just 'being hairy.'",
        bullets: [
          "Face & Jawline: Upper lip, chin, sideburns",
          "Chest & Abdomen: Around nipples, below belly button",
          "Back & Shoulders: Dark hair growth"
        ],
        highlight: "Hirsutism signals hormonal imbalance. It's not cosmetic—it's MEDICAL.",
        icon: "AlertTriangle"
      },
      {
        title: "The Hidden Problem",
        content: "Cosmetic removal masks the diagnosis doctors need to see.",
        bullets: [
          "You wax, thread, shave before appointments",
          "By appointment time, it's gone",
          "Doctor never sees the pattern",
          "Hormonal imbalance goes undiagnosed for years"
        ],
        highlight: "Document your hair growth with photos. Show your doctor the pattern BEFORE removal.",
        icon: "Camera"
      },
      {
        title: "Your Hormonal Orchestra",
        content: "The pituitary gland at your brain's base controls everything:",
        columns: [
          {
            header: "Pituitary Hormones",
            items: ["LH & FSH - ovulation", "Prolactin - cycle regularity", "TSH - thyroid signals", "ACTH - adrenal function"]
          },
          {
            header: "What They Control",
            items: ["Egg development", "Menstrual cycles", "Metabolism", "Stress response"]
          }
        ],
        icon: "Activity"
      },
      {
        title: "The Thyroid Connection",
        content: "Thyroid disorders often coexist with PCOS:",
        cards: [
          { title: "30%", stat: "30%", desc: "PCOS patients have thyroid issues", showPie: true, pieColor: '#4A0E4E' },
          { title: "3X", stat: "3X", desc: "higher Hashimoto's risk" },
          { title: "25%", stat: "25%", desc: "misdiagnosed cases", showPie: true, pieColor: '#E11D48' }
        ],
        highlight: "Test TSH, Free T3, Free T4, AND thyroid antibodies—not just TSH alone.",
        icon: "Thermometer"
      },
      {
        title: "Essential Lab Testing",
        content: "Demand COMPLETE panels. Partial testing misses diagnoses.",
        columns: [
          {
            header: "Androgens",
            items: ["Total & free testosterone", "DHEA-S", "Androstenedione"]
          },
          {
            header: "Pituitary",
            items: ["LH, FSH (check ratio)", "Prolactin", "TSH"]
          }
        ],
        icon: "FileText"
      },
      {
        title: "More Essential Tests",
        content: "Don't accept incomplete workups:",
        columns: [
          {
            header: "Thyroid Panel",
            items: ["TSH", "Free T3", "Free T4", "Thyroid antibodies"]
          },
          {
            header: "Metabolic",
            items: ["Fasting insulin", "Glucose, HbA1c", "Lipid panel", "17-OH progesterone"]
          }
        ],
        icon: "Clipboard"
      },
      {
        title: "Treatment Options",
        content: "Multiple approaches exist beyond birth control:",
        bullets: [
          "Spironolactone: Blocks testosterone receptors (6+ months for results)",
          "Birth Control: Regulates cycles, reduces androgens",
          "Metformin: Improves insulin sensitivity",
          "Lifestyle: 5-10% weight loss improves ovulation"
        ],
        icon: "Pill"
      },
      {
        title: "Myth Busters",
        content: "Common misconceptions debunked:",
        bullets: [
          "❌ 'I'm just hairy from my ethnicity' → Sudden changes need evaluation",
          "❌ 'High testosterone = high libido' → Actually often decreases desire",
          "❌ 'PCOS only affects overweight women' → Lean PCOS exists"
        ],
        icon: "XCircle"
      },
      {
        title: "Your Action Plan",
        content: "Before your next PCS or appointment:",
        bullets: [
          "Request copies of ALL lab results and imaging",
          "Build your portable medical file",
          "Know your TRICARE rights for diagnostic testing",
          "Document symptoms with dates and photos"
        ],
        cta: true,
        icon: "CheckCircle"
      }
    ]
  },
  {
    id: 7,
    title: "Hirsutism: When Unwanted Hair Signals More",
    subtitle: "Understanding the Medical Significance",
    excerpt: 'Why proper diagnosis matters for your long-term health, fertility, and quality of life.',
    category: 'Hormonal Health',
    topicCategory: "Women's Health",
    readTime: '9 min',
    image: 'https://images.unsplash.com/photo-1576091160550-2173dba999ef?w=800',
    date: '2026-01-28',
    author: 'CADENCE Medical Consulting, LLC',
    authorRole: 'Patient Advocacy & Health Equity Experts',
    isSlideshow: true,
    slides: [
      {
        title: "Beyond 'Just Being Hairy'",
        content: "Hirsutism affects millions of women, yet it's often dismissed.",
        highlight: "It represents a critical warning sign of underlying hormonal imbalance.",
        icon: "AlertTriangle"
      },
      {
        title: "Clinical Definition",
        content: "Thick, dark, coarse hair in male-pattern distribution:",
        bullets: [
          "Face: chin, upper lip, sideburns",
          "Chest and lower abdomen",
          "Back, inner thighs, buttocks",
          "This is TERMINAL hair responding to androgens"
        ],
        highlight: "Hair on forearms is normal. Hair on chin/chest in a vertical line needs evaluation.",
        icon: "Eye"
      },
      {
        title: "Why Location Matters",
        content: "The distribution pattern is diagnostic:",
        columns: [
          {
            header: "Normal (Genetic)",
            items: ["Forearm hair", "Lower leg hair", "Fine vellus hair"]
          },
          {
            header: "Abnormal (Hormonal)",
            items: ["Chin/upper lip", "Chest/nipple area", "Lower abdomen line", "Upper back"]
          }
        ],
        icon: "MapPin"
      },
      {
        title: "The Anatomy of PCOS",
        content: "Affects up to 10% of women. It's a METABOLIC syndrome:",
        bullets: [
          "Multiple small follicles fail to mature",
          "Elevated LH disrupts follicle development",
          "Ovaries produce excess androgens",
          "Insulin resistance worsens everything"
        ],
        highlight: "Despite the name, it's NOT primarily about ovarian cysts.",
        icon: "Activity"
      },
      {
        title: "Long-Term Risks",
        content: "Untreated hormonal imbalance increases risk for:",
        cards: [
          { title: "Diabetes", stat: "2-4X", desc: "higher risk" },
          { title: "Heart Disease", stat: "↑", desc: "cardiovascular risk" },
          { title: "Infertility", stat: "Common", desc: "ovulation issues" },
          { title: "Endometrial", stat: "↑", desc: "cancer risk" }
        ],
        icon: "Heart"
      },
      {
        title: "It's Not Always PCOS",
        content: "Other conditions to rule out:",
        bullets: [
          "Congenital Adrenal Hyperplasia (CAH) - test 17-OH progesterone",
          "Prolactinoma - benign pituitary tumor",
          "Cushing's Syndrome - excess cortisol",
          "Androgen-Secreting Tumors - rare but serious"
        ],
        highlight: "Red Flag: Rapidly progressive hirsutism or testosterone >200 needs IMMEDIATE evaluation.",
        icon: "Search"
      },
      {
        title: "Myth Busters",
        content: "Let's debunk common misconceptions:",
        bullets: [
          "❌ 'It's just my ethnicity' → Sudden changes still need workup",
          "❌ 'More testosterone = more desire' → Often DECREASES libido",
          "❌ 'Remove hair, problem solved' → Underlying imbalance remains"
        ],
        icon: "XCircle"
      },
      {
        title: "The Spironolactone Solution",
        content: "How this medication works:",
        bullets: [
          "Blocks testosterone from binding to hair follicles",
          "Reduces androgen production",
          "Prevents conversion to potent DHT",
          "Results take 6-12 months—be patient!"
        ],
        highlight: "Doesn't eliminate existing hair, but prevents new growth and makes hair finer.",
        icon: "Pill"
      },
      {
        title: "Laser Hair Removal: Timing Matters",
        content: "Follow these steps for best results:",
        bullets: [
          "Step 1: Stabilize hormones FIRST (6-12 months)",
          "Step 2: Then begin laser series (6-8 sessions)",
          "Step 3: Maintain hormone treatment"
        ],
        highlight: "⚠️ Once hair turns GRAY, laser becomes ineffective. Start while hair is dark!",
        icon: "Zap"
      },
      {
        title: "Self-Esteem Matters",
        content: "The psychological impact is real:",
        bullets: [
          "Feeling 'unfeminine' or self-conscious",
          "Avoiding intimacy or social situations",
          "Hours spent managing unwanted hair",
          "Mental load of constant vigilance"
        ],
        highlight: "You deserve better. Hirsutism is a MEDICAL condition, not a personal failing.",
        icon: "Heart"
      },
      {
        title: "Your Action Plan",
        content: "Take control of your health:",
        bullets: [
          "Request comprehensive evaluation (testosterone, DHEA-S, LH, FSH, TSH)",
          "Seek endocrinology if dismissed by PCM",
          "Document symptoms with dated photos",
          "Commit to treatment—results take months"
        ],
        cta: true,
        icon: "CheckCircle"
      },
      {
        title: "When CADENCE Can Help",
        content: "We're here to support your journey:",
        bullets: [
          "Help you understand which tests to request",
          "Review lab results and explain what they mean",
          "Prepare you to advocate for specialist referrals",
          "Provide second opinions on treatment plans"
        ],
        cta: true,
        icon: "Users"
      }
    ]
  },
  {
    id: 'stop-guessing',
    title: "Stop Guessing About Your Health",
    subtitle: "A Complete Guide to CADENCE Second Opinions",
    excerpt: "Facing a complex diagnosis? Feeling overwhelmed by conflicting medical advice? Discover how CADENCE Medical Consulting, LLC provides expert second opinions that change lives.",
    category: "Patient Advocacy",
    topicCategory: 'Adult Health',
    image: "https://images.unsplash.com/photo-1584432810601-6c7f27d2362b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3MjQyMTd8MHwxfHNlYXJjaHw0fHx3b21hbiUyMGhlYWx0aGNhcmUlMjB3ZWxsbmVzcyUyMGNvbmZpZGVudCUyMHBhdGllbnR8ZW58MHx8fHwxNzcwMDcxMjk5fDA&ixlib=rb-4.1.0&q=85",
    date: "Feb 2, 2026",
    readTime: "8 min",
    author: "CADENCE Medical Consulting, LLC",
    authorRole: "Expert Medical Advocacy Team",
    featured: false,
    isSlideshow: true,
    slides: [
      {
        title: "Stop Guessing About Your Health",
        content: "Facing a complex diagnosis? Feeling overwhelmed by conflicting medical advice? You deserve clarity and confidence in your healthcare decisions.",
        highlight: "Swipe to discover how CADENCE Medical Consulting, LLC provides expert second opinions that change lives.",
        image: "https://images.unsplash.com/photo-1584432810601-6c7f27d2362b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3MjQyMTd8MHwxfHNlYXJjaHw0fHx3b21hbiUyMGhlYWx0aGNhcmUlMjB3ZWxsbmVzcyUyMGNvbmZpZGVudCUyMHBhdGllbnR8ZW58MHx8fHwxNzcwMDcxMjk5fDA&ixlib=rb-4.1.0&q=85",
        icon: "Heart"
      },
      {
        title: "CADENCE Medical Second Opinion",
        content: "Gain clarity and confidence in your diagnosis with comprehensive medical review from expert advocates who put YOU first.",
        cards: [
          { title: "Share Your Records", stat: "Step 1", desc: "Send us your medical history and diagnostic reports" },
          { title: "Deep Dive Analysis", stat: "Step 2", desc: "We thoroughly review and research your case" },
          { title: "Your Clarity Session", stat: "Step 3", desc: "Get actionable insights in a detailed consultation" }
        ],
        highlight: "Your Expert Advocate in Complex Health",
        icon: "FileText"
      },
      {
        title: "Why Second Opinions Matter",
        content: "The numbers tell a compelling story about the impact of getting a second opinion:",
        barChart: [
          { label: "Diagnosis Changed", value: 88 },
          { label: "Treatment Plan Altered", value: 40 },
          { label: "Unnecessary Surgery Avoided", value: 21 },
          { label: "Cost Savings Achieved", value: 65 }
        ],
        highlight: "We cut through the confusion, analyze your records, and give you a clear, actionable path forward—ensuring your treatment plan is your best&nbsp;possible&nbsp;option.",
        image: "https://images.unsplash.com/photo-1659353888906-adb3e0041693?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3MjQyMTd8MHwxfHNlYXJjaHwyfHx3b21hbiUyMGhlYWx0aGNhcmUlMjB3ZWxsbmVzcyUyMGNvbmZpZGVudCUyMHBhdGllbnR8ZW58MHx8fHwxNzcwMDcxMjk5fDA&ixlib=rb-4.1.0&q=85",
        icon: "TrendingUp"
      },
      {
        title: "Who We Serve",
        content: "We help patients and families facing complex health decisions:",
        columns: [
          {
            header: "Cancer Diagnoses",
            items: ["New cancer diagnoses needing validation", "Clarity on treatment options", "Before making life-changing decisions"]
          },
          {
            header: "Complex Conditions",
            items: ["Autoimmune conditions", "Chronic illnesses", "Confusing symptoms", "Care coordination needs"]
          }
        ],
        icon: "Users"
      },
      {
        title: "Who We Serve (Continued)",
        content: "Our services extend to those facing major decisions:",
        columns: [
          {
            header: "Major Surgery Decisions",
            items: ["Significant surgical procedures", "Ensuring the right choice", "All available information reviewed"]
          },
          {
            header: "Family Advocates",
            items: ["Overwhelmed loved ones", "Advocating during health crisis", "Expert guidance needed"]
          }
        ],
        image: "https://images.unsplash.com/photo-1766808982363-7df749493298?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwxfHxlbGRlcmx5JTIwY2FyZSUyMGZhbWlseSUyMGNhcmVnaXZlciUyMHN1cHBvcnR8ZW58MHx8fHwxNzcwMDcxMzIyfDA&ixlib=rb-4.1.0&q=85",
        icon: "Heart"
      },
      {
        title: "Our Investment in You",
        content: "Transparent pricing with no hidden fees:",
        cards: [
          { title: "Free Discovery Call", stat: "15 min", desc: "Genuine assessment of how we can help—not a sales pitch" },
          { title: "Comprehensive Package", stat: "$1,500-$2,500", desc: "Complete record review, research, and detailed written report" },
          { title: "Clarity Consultation", stat: "60 min", desc: "We explain findings and provide your clear, actionable path forward" }
        ],
        highlight: "No hidden fees. No surprises. Just expert advocacy when you need it most.",
        icon: "DollarSign"
      },
      {
        title: "Strategic Partnerships",
        content: "We collaborate with trusted organizations to expand access to expert medical advocacy:",
        bullets: [
          "Patient Advocacy Groups — Partnering with disease-specific organizations like the American Cancer Society and Lupus Foundation",
          "Financial Planners — Working with professionals whose clients face serious health crises",
          "Elder Law Attorneys — Collaborating with legal experts to help their clients navigate complex medical situations"
        ],
        icon: "Handshake"
      },
      {
        title: "Content That Empowers",
        content: "Follow us for expert insights across four powerful content pillars:",
        columns: [
          {
            header: "Educate & Empower",
            items: ["Lab marks your doctor might miss", "Hidden medication costs", "Decoding medical reports"]
          },
          {
            header: "Demystify & Disrupt",
            items: ["Behind-the-scenes advocacy", "Our 3-step process", "Real case analysis"]
          }
        ],
        icon: "BookOpen"
      },
      {
        title: "Must-Ask Doctor Questions",
        content: "Your doctor's visit is only 15 minutes. Make it count with these essential questions:",
        bullets: [
          "1️⃣ What is the root cause? — \"What's the underlying driver of these symptoms?\" Don't just treat symptoms—understand the source.",
          "2️⃣ What are my OTHER options? — \"Beyond this medication, what are my treatment alternatives?\" Explore all possibilities.",
          "3️⃣ What's the cost? — \"Is there a generic or cheaper alternative?\" You shouldn't have to overpay for your health."
        ],
        image: "https://images.unsplash.com/photo-1758691463000-08b98131daf3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHwxfHxkb2N0b3IlMjBwYXRpZW50JTIwY29uc3VsdGF0aW9uJTIwbWVkaWNhbCUyMHJldmlld3xlbnwwfHx8fDE3NzAwNzEyODB8MA&ixlib=rb-4.1.0&q=85",
        icon: "MessageCircle"
      },
      {
        title: "Medication Cost Hack",
        content: "Stop overpaying for prescriptions. This is what we do for our clients every day:",
        bullets: [
          "1️⃣ Check GoodRx — Compare pharmacy prices in your area",
          "2️⃣ Try Cost Plus Drugs — Often shows massive savings on the same medication",
          "3️⃣ Save Thousands — Our clients regularly save $1,200+ annually"
        ],
        highlight: "Want us to review your medication costs? We'll find every possible saving.",
        image: "https://images.unsplash.com/photo-1630094539413-a69caf88ce7d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3MjQyMTd8MHwxfHNlYXJjaHwxfHxwcmVzY3JpcHRpb24lMjBtZWRpY2F0aW9uJTIwcGhhcm1hY3klMjBwaWxsc3xlbnwwfHx8fDE3NzAwNzEzMTF8MA&ixlib=rb-4.1.0&q=85",
        icon: "Pill"
      },
      {
        title: "The Hormone Series",
        content: "A comprehensive multi-week content series addressing hormonal health:",
        cards: [
          { title: "Week 1: Recognition", stat: "Reel", desc: "5 Signs Your Hormones Are Out of Whack" },
          { title: "Week 2: Connection", stat: "Carousel", desc: "The Estrogen & Cortisol Connection" },
          { title: "Week 3: Deep Dive", stat: "Article", desc: "Why Standard Thyroid Tests Aren't Enough" },
          { title: "Week 4: Engagement", stat: "Live Q&A", desc: "Ask the CMO Anything About Hormones" }
        ],
        icon: "Activity"
      },
      {
        title: "Your Free Resource",
        content: "Download our comprehensive guide to preparing for a second opinion consultation:",
        bullets: [
          "📋 Gather Your Records — Complete list of documents including test results, imaging, and treatment history",
          "❓ Prepare Your Questions — Template for organizing your concerns and ensuring nothing gets overlooked",
          "📖 Understand the Process — Step-by-step guide to what happens during a second opinion review"
        ],
        highlight: "Get \"The Patient's Checklist: How to Prepare for a Second Opinion\" — Link in bio!",
        icon: "Download"
      },
      {
        title: "Real Impact, Real Results",
        content: "Hear from our clients:",
        bullets: [
          "\"My CADENCE report saved me $1,200 on my medications and gave me the confidence to advocate for better treatment options.\" — Sarah M.",
          "\"The second opinion changed my entire treatment plan. I'm so grateful I didn't proceed with the original recommendation without this expert review.\" — Michael T."
        ],
        highlight: "Join the growing community of empowered patients who've gained clarity and confidence through CADENCE Medical Consulting, LLC.",
        image: "https://images.unsplash.com/photo-1763631045896-04d2e60048ae?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwyfHxlbGRlcmx5JTIwY2FyZSUyMGZhbWlseSUyMGNhcmVnaXZlciUyMHN1cHBvcnR8ZW58MHx8fHwxNzcwMDcxMzIyfDA&ixlib=rb-4.1.0&q=85",
        icon: "Star"
      },
      {
        title: "Ready for Clarity?",
        content: "CADENCE Medical Consulting, LLC is officially open for business. Stop guessing about your health.",
        cards: [
          { title: "Schedule Your Free Discovery Call", stat: "15 min", desc: "to see if we can help" },
          { title: "Founder's Bonus", stat: "Special", desc: "First 10 clients receive special pricing" },
          { title: "Link in Bio", stat: "Visit", desc: "our website to get started today" }
        ],
        highlight: "Your health deserves an advocate. Let's be yours. Tag someone who needs expert medical guidance!",
        cta: true,
        icon: "Calendar"
      }
    ]
  },
  {
    id: 15,
    title: "Stubborn Weight Gain: When 'Eat Less, Move More' Isn't Enough",
    slug: "stubborn-weight-gain",
    excerpt: "Discover the hidden hormonal and metabolic reasons behind unexplained weight gain that diet and exercise can't fix.",
    category: "Metabolic Health",
    topicCategory: "Adult Health",
    readTime: "8 min",
    date: "2026-02-05",
    image: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=800",
    author: "CADENCE Medical Team",
    isSlideshow: true,
    slides: [
      {
        title: "Beyond Calories",
        content: "If you've been eating well and exercising but still gaining weight, you're not alone—and it's not your fault.",
        highlight: "Traditional advice 'eat less, move more' isn't always enough when hormones and metabolism are off balance.",
        image: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=800",
        icon: "Activity"
      },
      {
        title: "Your Body's Balancing Act",
        content: "Weight is controlled by your metabolism—a complex system of hormones telling your body to store or burn fuel.",
        bullets: [
          "If your body is a car, calories are the gas",
          "Hormones and metabolism are the driver and engine settings",
          "If those are off, you'll store fuel (fat) even when you don't need to"
        ],
        icon: "Zap"
      },
      {
        title: "Hidden Culprits: Hormone Disruptors",
        content: "Four key hormone systems can sabotage your weight—even when you're doing everything right:",
        cards: [
          { title: "Thyroid", stat: "Metabolism", desc: "Controls how fast you burn calories", showPie: false },
          { title: "Cortisol", stat: "Stress", desc: "Signals fat storage under chronic stress", showPie: false },
          { title: "Sex Hormones", stat: "Distribution", desc: "Affects where fat is stored", showPie: false },
          { title: "Insulin", stat: "Storage", desc: "Controls blood sugar and fat storage", showPie: false }
        ],
        icon: "AlertTriangle"
      },
      {
        title: "Thyroid: Your Metabolic Thermostat",
        content: "An underactive thyroid means your body burns fewer calories at rest.",
        columns: [
          {
            header: "Slows Everything Down",
            items: ["Slower metabolism", "Fewer calories burned at rest", "Lower body temperature"]
          },
          {
            header: "Classic Symptoms",
            items: ["Persistent fatigue", "Feeling cold all the time", "Unexplained weight gain"]
          }
        ],
        icon: "Thermometer"
      },
      {
        title: "Stress Hormones: The Cortisol Effect",
        content: "Prolonged elevated cortisol signals your body to store fat, especially in the abdomen.",
        bullets: [
          "Chronic stress keeps cortisol elevated",
          "'Stress belly' - fat stored deep around organs",
          "This is the most dangerous type of fat for long-term health",
          "Even healthy eating can't overcome chronically high cortisol"
        ],
        highlight: "Managing stress isn't just good for your mind—it's essential for your waistline.",
        icon: "Heart"
      },
      {
        title: "Sex Hormones & Insulin Resistance",
        content: "These two systems work together to determine where and how your body stores fat.",
        columns: [
          {
            header: "Sex Hormone Imbalances",
            items: ["Testosterone or estrogen imbalances", "Shift where body stores fat", "Common in perimenopause/menopause"]
          },
          {
            header: "Insulin Resistance",
            items: ["Body stores calories as fat more easily", "Especially around the midsection", "Often precedes Type 2 diabetes"]
          }
        ],
        icon: "Activity"
      },
      {
        title: "Red Flags: Other Sneaky Causes",
        content: "Beyond hormones, other factors can promote weight gain:",
        columns: [
          {
            header: "Medications",
            items: ["Mood medications", "Blood pressure drugs", "Allergy medications", "Some diabetes treatments"]
          },
          {
            header: "Poor Sleep Quality",
            items: ["Disrupts ghrelin (hunger hormone)", "Disrupts leptin (fullness hormone)", "Makes you eat more without realizing"]
          }
        ],
        icon: "Pill"
      },
      {
        title: "When to Talk to Your Doctor",
        content: "Seek medical evaluation if you're experiencing:",
        bullets: [
          "Gaining weight despite consistent healthy routine",
          "Rapid gain: 10+ lbs in one month",
          "Weight concentrated on face and torso",
          "Weight gain with fatigue, hair loss, or feeling cold",
          "Family history of thyroid or metabolic conditions"
        ],
        highlight: "These patterns suggest a metabolic or hormonal cause that needs investigation.",
        icon: "Stethoscope"
      },
      {
        title: "The Right Tests to Find Your Cause",
        content: "We look for clues in your blood to move from frustration to clarity:",
        cards: [
          { title: "Thyroid Panel", stat: "TSH & T4", desc: "Check your metabolic engine" },
          { title: "Blood Sugar", stat: "HbA1c", desc: "Reveal insulin resistance" },
          { title: "Sex Hormones", stat: "Complete", desc: "Testosterone, estrogen, SHBG" },
          { title: "Cortisol", stat: "Patterns", desc: "When chronic stress is suspected" }
        ],
        icon: "FileText"
      },
      {
        title: "Personalized Treatment That Works",
        content: "Fixing the cause is more effective than just fighting the symptom.",
        columns: [
          {
            header: "Hormone Issues",
            items: ["Thyroid medication", "Hormone optimization", "Targeted supplementation"]
          },
          {
            header: "Insulin Resistance",
            items: ["Specific dietary changes", "Sometimes medication", "Blood sugar management"]
          },
          {
            header: "Lifestyle Triggers",
            items: ["Sleep improvement plans", "Stress management", "Exercise optimization"]
          }
        ],
        icon: "Target"
      },
      {
        title: "Get Answers, Not Guesswork",
        content: "CADENCE analyzes your metabolic labs to create a personalized plan that targets your body's specific hurdles.",
        highlight: "Ready to understand what's really happening? Stop guessing. Start healing.",
        cta: true,
        icon: "Lightbulb"
      }
    ]
  },
  {
    id: 16,
    title: "Tired, Gaining Weight, Can't Sleep?",
    slug: "tired-gaining-weight-cant-sleep",
    excerpt: "Your body is trying to tell you something important. Discover how sleep affects your weight, mood, and overall health.",
    category: "Sleep & Wellness",
    topicCategory: "Adult Health",
    readTime: "7 min",
    date: "2026-02-05",
    image: "https://images.unsplash.com/photo-1541781774459-bb2af2f05b55?w=800",
    author: "CADENCE Medical Team",
    isSlideshow: true,
    slides: [
      {
        title: "Your Body is Sending Signals",
        content: "Fatigue, weight gain, and sleep problems often share a common root cause.",
        highlight: "When these symptoms cluster together, your body is trying to tell you something important.",
        image: "https://images.unsplash.com/photo-1541781774459-bb2af2f05b55?w=800",
        icon: "AlertTriangle"
      },
      {
        title: "Sleep is Your Body's Repair Shift",
        content: "Every night, your body performs critical maintenance:",
        cards: [
          { title: "Brain Detox", stat: "Cleanse", desc: "Toxins cleared, memories consolidated" },
          { title: "Hormone Reset", stat: "Balance", desc: "Hunger, stress, metabolism regulated" },
          { title: "Tissue Repair", stat: "Rebuild", desc: "Muscles heal, damage repaired" },
          { title: "Immune Boost", stat: "Protect", desc: "Defense systems strengthened" }
        ],
        highlight: "Skipping this repair shift night after night? Problems pile up fast.",
        icon: "Moon"
      },
      {
        title: "The Ripple Effect of Poor Sleep",
        content: "Sleep problems don't stay isolated—they affect everything:",
        barChart: [
          { label: "Mood Impact", value: 85 },
          { label: "Weight Disruption", value: 75 },
          { label: "Heart & Metabolic Risk", value: 70 },
          { label: "Brain Fog & Focus", value: 80 }
        ],
        highlight: "Addressing sleep is often the most effective first step in resolving other health problems.",
        icon: "Activity"
      },
      {
        title: "Hidden Physical Causes of Insomnia",
        content: "It's not always just stress or racing thoughts:",
        columns: [
          {
            header: "Sleep Apnea",
            items: ["Brief breathing stops", "Disrupts sleep without waking you", "Major cause of unrefreshing rest"]
          },
          {
            header: "Restless Legs",
            items: ["Irresistible urge to move", "Often tied to low iron stores", "Worse at night"]
          },
          {
            header: "Physical Discomfort",
            items: ["Pain or acid reflux", "Frequent urination", "Fragments your sleep cycles"]
          }
        ],
        icon: "Search"
      },
      {
        title: "The Key Question",
        content: "Is insomnia my main problem, or a symptom of something else?",
        highlight: "This distinction is critical for determining the right treatment path.",
        bullets: [
          "Primary insomnia: Sleep is the core issue",
          "Secondary insomnia: Sleep problems caused by another condition",
          "The treatment approach differs significantly",
          "Identifying root cause leads to lasting relief"
        ],
        icon: "HelpCircle"
      },
      {
        title: "Finding Root Causes",
        content: "We investigate physical triggers others might miss:",
        cards: [
          { title: "Ferritin", stat: "Iron", desc: "Low stores cause restless legs", showPie: false },
          { title: "Vitamin D", stat: "Test", desc: "Deficiency linked to poor sleep", showPie: false },
          { title: "Thyroid", stat: "TSH", desc: "Overactive = feeling constantly wired", showPie: false },
          { title: "Sleep Diary", stat: "Track", desc: "Often more revealing than labs", showPie: false }
        ],
        icon: "FileText"
      },
      {
        title: "Better Solutions Exist",
        content: "Evidence-based treatments that actually work:",
        columns: [
          {
            header: "CBT-I: Gold Standard",
            items: ["Cognitive Behavioral Therapy for Insomnia", "Fixes behaviors ruining sleep", "More effective than sleeping pills", "Lasting results"]
          },
          {
            header: "Targeted Treatments",
            items: ["CPAP for sleep apnea", "Iron supplements for restless legs", "Pain management strategies", "Hormone optimization"]
          }
        ],
        icon: "CheckCircle"
      },
      {
        title: "Ready to Find Your Root Cause?",
        content: "CADENCE identifies your path—checking physical triggers and advocating for proven solutions.",
        highlight: "Stop guessing. Start healing. Real solutions begin with understanding what's really happening.",
        cta: true,
        icon: "Target"
      }
    ]
  },
  {
    id: 17,
    title: "Depression & Anxiety: It's Your Mind, Body, and Brain Chemistry",
    slug: "depression-anxiety-brain-chemistry",
    excerpt: "Understanding the biological basis of mental health conditions and how physical health affects your emotional well-being.",
    category: "Mental Health",
    topicCategory: "Adult Health",
    readTime: "9 min",
    date: "2026-02-05",
    image: "https://images.unsplash.com/photo-1493836512294-502baa1986e2?w=800",
    author: "CADENCE Medical Team",
    isSlideshow: true,
    slides: [
      {
        title: "Real Conditions with a Biological Basis",
        content: "Depression and anxiety are not about being weak or just 'thinking positive.'",
        highlight: "These are medical conditions rooted in your body's biology—and they deserve medical attention.",
        image: "https://images.unsplash.com/photo-1493836512294-502baa1986e2?w=800",
        icon: "Brain"
      },
      {
        title: "Your Brain's Chemical Messengers",
        content: "Your brain uses special chemicals called neurotransmitters to send messages:",
        cards: [
          { title: "Serotonin", stat: "Mood", desc: "Regulates mood, sleep, calm" },
          { title: "Dopamine", stat: "Reward", desc: "Controls motivation, pleasure" },
          { title: "Norepinephrine", stat: "Energy", desc: "Affects alertness, focus" }
        ],
        highlight: "When these signals are weak or out of balance, specific symptoms emerge.",
        icon: "Zap"
      },
      {
        title: "Serotonin System Issues",
        content: "When serotonin signaling is disrupted, you may experience:",
        bullets: [
          "Anxiety & Rumination: Racing thoughts and constant worry",
          "Sleep Problems: Insomnia and disrupted rest patterns",
          "Hypervigilance: Feeling constantly 'on edge'",
          "Mood instability and irritability"
        ],
        icon: "AlertTriangle"
      },
      {
        title: "Dopamine & Norepinephrine Issues",
        content: "When these systems are affected, you may notice:",
        bullets: [
          "Low Motivation: Difficulty starting or completing tasks",
          "Anhedonia: Unable to feel pleasure or joy",
          "Fatigue: Persistent exhaustion despite rest",
          "Brain Fog: Difficulty concentrating and making decisions"
        ],
        highlight: "These systems interact, which is why symptoms often overlap.",
        icon: "Activity"
      },
      {
        title: "How Medications Actually Work",
        content: "SSRIs and SNRIs are 'reuptake inhibitors'—they don't give you serotonin.",
        columns: [
          {
            header: "The 'Save & Rebalance' Effect",
            items: ["Help brain save and reuse its own supply", "Slow down normal clean-up process", "More neurotransmitter available", "Signals work more efficiently"]
          },
          {
            header: "Why It Takes Time",
            items: ["Brain needs weeks to adapt", "Rebuilding healthy signaling pathways", "Depends on how depleted you were", "Patience is part of healing"]
          }
        ],
        icon: "Pill"
      },
      {
        title: "Initial Side Effects Explained",
        content: "Why you might feel worse before feeling better:",
        bullets: [
          "Your gut has neurons using the same serotonin system",
          "Temporary digestive changes are normal",
          "Body adapts within 1-2 weeks typically",
          "Side effects usually decrease as brain adjusts"
        ],
        highlight: "Understanding the science helps you stick with treatment through the adjustment period.",
        icon: "Clock"
      },
      {
        title: "When Your Body Mimics Your Mind",
        content: "Many physical illnesses can create symptoms identical to depression and anxiety:",
        cards: [
          { title: "Thyroid", stat: "Disorders", desc: "Affects energy, mood, metabolism" },
          { title: "Vitamin", stat: "Deficiencies", desc: "Low D, B12, or iron levels" },
          { title: "Hormones", stat: "Imbalances", desc: "Including low testosterone" },
          { title: "Inflammation", stat: "Chronic", desc: "Body-wide systemic response" }
        ],
        highlight: "A crucial check-up can reveal the real cause.",
        icon: "Stethoscope"
      },
      {
        title: "How CADENCE Helps You",
        content: "We identify underlying physical issues that affect your treatment:",
        columns: [
          {
            header: "Rule Out Physical Causes",
            items: ["Check thyroid function", "Test Vitamin D and B12", "Assess testosterone levels", "Review metabolic panels"]
          },
          {
            header: "Target Treatment",
            items: ["Diagnose based on symptom patterns", "Target correct neurotransmitter systems", "Coordinate with mental health providers", "Create comprehensive care plan"]
          }
        ],
        icon: "Target"
      },
      {
        title: "You Deserve Comprehensive Care",
        content: "Effective treatment combines medication, therapy, and lifestyle medicine.",
        highlight: "CADENCE provides the medical clarity you need to build a targeted treatment plan that works.",
        bullets: [
          "Rule out physical mimickers first",
          "Identify the right treatment pathway",
          "Coordinate between providers",
          "Support your whole-person healing"
        ],
        cta: true,
        icon: "Heart"
      }
    ]
  },
  {
    id: 18,
    title: "Insomnia: It's Not Just About Being Tired",
    slug: "insomnia-not-just-tired",
    excerpt: "Discover what's really happening when you can't sleep and learn about the far-reaching effects of sleep deprivation.",
    category: "Sleep Health",
    topicCategory: "Adult Health",
    readTime: "8 min",
    date: "2026-02-05",
    image: "https://images.unsplash.com/photo-1515894203077-9cd36032142f?w=800",
    author: "CADENCE Medical Team",
    isSlideshow: true,
    slides: [
      {
        title: "More Than Just Feeling Tired",
        content: "Insomnia affects far more than your energy levels—it impacts every system in your body.",
        highlight: "Understanding what's really happening when you can't sleep is the first step to real solutions.",
        image: "https://images.unsplash.com/photo-1515894203077-9cd36032142f?w=800",
        icon: "Moon"
      },
      {
        title: "Sleep is Your Body's Repair Shift",
        content: "Every night, your body performs critical maintenance that can't happen any other way:",
        cards: [
          { title: "Tissue Repair", stat: "Heal", desc: "Body rebuilds while you rest" },
          { title: "Memory", stat: "Process", desc: "Experiences become lasting memories" },
          { title: "Hormones", stat: "Reset", desc: "Critical levels return to optimal" },
          { title: "Brain Detox", stat: "Cleanse", desc: "Waste cleared from neural pathways" }
        ],
        highlight: "Skipping this repair shift is like ignoring car maintenance—problems pile up in every system.",
        icon: "Activity"
      },
      {
        title: "The Ripple Effect of Poor Sleep",
        content: "Poor sleep has widespread negative consequences:",
        columns: [
          {
            header: "Mood Impact",
            items: ["Fuels irritability", "Increases anxiety", "Raises depression risk"]
          },
          {
            header: "Weight Disruption",
            items: ["Hunger hormones go haywire", "Increases cravings", "Slows metabolism"]
          },
          {
            header: "Heart & Brain Risk",
            items: ["Raises blood pressure", "Blood sugar issues", "Destroys focus & memory"]
          }
        ],
        icon: "AlertTriangle"
      },
      {
        title: "Sleep First, Then Everything Else",
        content: "If you're struggling with weight, mood, or focus, your sleep problem might be the root cause.",
        highlight: "Addressing sleep is often the most effective first step in resolving other health problems.",
        barChart: [
          { label: "Weight Management Success", value: 72 },
          { label: "Mood Improvement", value: 85 },
          { label: "Cognitive Function", value: 78 },
          { label: "Immune Function", value: 68 }
        ],
        icon: "TrendingUp"
      },
      {
        title: "Beyond 'Can't Shut Off My Brain'",
        content: "Physical causes often underlie insomnia—and identifying them is crucial:",
        columns: [
          {
            header: "Sleep Apnea",
            items: ["Brief breathing stops", "Disrupts sleep without waking you", "Major cause of unrefreshing rest"]
          },
          {
            header: "Restless Legs",
            items: ["Irresistible urge to move", "Often tied to low iron stores", "Worse when trying to rest"]
          },
          {
            header: "Physical Discomfort",
            items: ["Pain or acid reflux", "Frequent urination", "Fragments sleep cycles"]
          }
        ],
        icon: "Search"
      },
      {
        title: "The First Question to Ask",
        content: "Is my insomnia the main problem, or is it a symptom of something else?",
        highlight: "This distinction is critical for determining the appropriate treatment path.",
        bullets: [
          "Primary insomnia needs behavioral intervention",
          "Secondary insomnia needs underlying cause treated",
          "Both can be present simultaneously",
          "Correct diagnosis = lasting relief"
        ],
        icon: "HelpCircle"
      },
      {
        title: "How We Look for Root Causes",
        content: "Identifying underlying physical triggers is essential:",
        cards: [
          { title: "Ferritin", stat: "Iron", desc: "Common cause of restless legs", showPie: false },
          { title: "Vitamin D", stat: "Deficiency", desc: "Strongly linked to poor sleep", showPie: false },
          { title: "Thyroid TSH", stat: "Overactive", desc: "Can make you feel constantly wired", showPie: false },
          { title: "Sleep Diary", stat: "Patterns", desc: "Often more revealing than labs", showPie: false }
        ],
        icon: "FileText"
      },
      {
        title: "The Power of Tracking",
        content: "A simple sleep diary can be more revealing than any lab test:",
        bullets: [
          "Record bedtime, wake time, and awakenings",
          "Note caffeine, alcohol, and exercise timing",
          "Track naps and daytime sleepiness",
          "Patterns emerge quickly with consistent tracking",
          "This data guides precise interventions"
        ],
        icon: "Clipboard"
      },
      {
        title: "Better Solutions Exist",
        content: "Evidence-based approaches that actually work:",
        columns: [
          {
            header: "CBT-I: Gold Standard",
            items: ["Cognitive Behavioral Therapy for Insomnia", "Fixes thoughts and behaviors", "More effective than pills", "Results last after treatment ends"]
          },
          {
            header: "Targeted Interventions",
            items: ["CPAP for sleep apnea", "Iron for low ferritin", "Pain management strategies", "Addressing underlying conditions"]
          }
        ],
        icon: "CheckCircle"
      },
      {
        title: "From Desperate to Strategic",
        content: "CADENCE identifies underlying physical triggers and advocates for proven solutions.",
        highlight: "Stop guessing and start healing. Real solutions begin with understanding what's really keeping you awake.",
        cta: true,
        icon: "Target"
      }
    ]
  },
  {
    id: 19,
    title: "Low Testosterone: Getting the Full Picture for Your Health",
    slug: "low-testosterone-full-picture",
    excerpt: "Understanding the complete story of testosterone—beyond just the numbers. Learn what low T really means and how to get proper evaluation.",
    category: "Men's Health",
    topicCategory: "Men's Health",
    readTime: "9 min",
    date: "2026-02-06",
    image: "https://images.unsplash.com/photo-1571019614242-c5c5dee9f50b?w=800",
    author: "CADENCE Medical Team",
    isSlideshow: true,
    slides: [
      {
        title: "Beyond Low T Ads",
        content: "Low testosterone is real—but it's more complex than supplement commercials suggest.",
        highlight: "Understanding the full picture helps you get proper treatment, not just a quick fix.",
        image: "https://images.unsplash.com/photo-1571019614242-c5c5dee9f50b?w=800",
        icon: "Activity"
      },
      {
        title: "What Testosterone Does",
        content: "Testosterone is a key hormone affecting multiple body systems:",
        cards: [
          { title: "Muscle & Bone", stat: "Strength", desc: "Builds mass and bone density" },
          { title: "Energy", stat: "Vitality", desc: "Affects overall energy levels" },
          { title: "Mood", stat: "Mental", desc: "Influences mood and cognition" },
          { title: "Sexual", stat: "Function", desc: "Drives libido and performance" }
        ],
        icon: "Zap"
      },
      {
        title: "Symptoms of Low Testosterone",
        content: "Common signs that warrant evaluation:",
        columns: [
          {
            header: "Physical Signs",
            items: ["Fatigue despite adequate rest", "Loss of muscle mass", "Increased body fat", "Reduced bone density"]
          },
          {
            header: "Other Symptoms",
            items: ["Low libido", "Erectile dysfunction", "Mood changes", "Brain fog", "Poor concentration"]
          }
        ],
        icon: "AlertTriangle"
      },
      {
        title: "Why Testing Matters",
        content: "A single testosterone level doesn't tell the whole story:",
        bullets: [
          "Levels fluctuate throughout the day (highest in morning)",
          "Total testosterone vs. free testosterone matter differently",
          "Other hormones affect how testosterone works",
          "Underlying causes need to be identified"
        ],
        highlight: "Proper testing requires timing, multiple markers, and clinical context.",
        icon: "FileText"
      },
      {
        title: "The Complete Hormone Panel",
        content: "Beyond just 'total testosterone,' comprehensive evaluation includes:",
        cards: [
          { title: "Total T", stat: "Overall", desc: "Total testosterone level" },
          { title: "Free T", stat: "Active", desc: "Unbound, usable testosterone" },
          { title: "Bioavailable T", stat: "Usable", desc: "Free + loosely albumin-bound (tissue-ready)" },
          { title: "SHBG", stat: "Binding", desc: "Sex hormone binding globulin" },
          { title: "LH & FSH", stat: "Signals", desc: "Pituitary hormone signals" }
        ],
        icon: "Search"
      },
      {
        title: "Primary vs. Secondary Causes",
        content: "Low T can originate from different places:",
        columns: [
          {
            header: "Primary (Testicular)",
            items: ["Testes can't produce enough", "Direct testicular injury", "Genetic conditions", "High LH trying to compensate"]
          },
          {
            header: "Secondary (Pituitary)",
            items: ["Brain doesn't signal properly", "Pituitary gland issues", "Medications or tumors", "Low LH despite low T"]
          }
        ],
        highlight: "Identifying the source determines the right treatment approach.",
        icon: "Target"
      },
      {
        title: "Hidden Causes to Rule Out",
        content: "Many conditions can cause or worsen low testosterone:",
        bullets: [
          "Sleep apnea (major but treatable cause)",
          "Obesity and metabolic syndrome",
          "Chronic opioid use",
          "Type 2 diabetes",
          "Chronic stress and elevated cortisol",
          "Thyroid disorders"
        ],
        highlight: "Treating these underlying issues often improves testosterone naturally.",
        icon: "Eye"
      },
      {
        title: "Treatment Options",
        content: "When replacement is needed, options include:",
        columns: [
          {
            header: "Testosterone Replacement",
            items: ["Injections (most common)", "Gels and patches", "Pellets (implanted)", "Requires monitoring"]
          },
          {
            header: "Alternative Approaches",
            items: ["Clomiphene (preserves fertility)", "hCG therapy", "Lifestyle optimization", "Treating root causes first"]
          }
        ],
        icon: "Pill"
      },
      {
        title: "Important Considerations",
        content: "Before starting testosterone therapy:",
        bullets: [
          "Fertility impact: TRT can reduce sperm production",
          "Prostate monitoring: Regular PSA checks needed",
          "Blood thickness: Hematocrit levels must be tracked",
          "Cardiovascular: Heart health monitoring important",
          "Not a quick fix: Requires ongoing management"
        ],
        highlight: "Informed decisions require understanding both benefits and risks.",
        icon: "Shield"
      },
      {
        title: "CADENCE Can Help",
        content: "We provide comprehensive evaluation and advocacy for men's hormonal health:",
        bullets: [
          "Review your existing labs and symptoms",
          "Identify gaps in your evaluation",
          "Help you ask the right questions",
          "Advocate for complete testing",
          "Navigate treatment decisions"
        ],
        highlight: "Stop guessing. Get the full picture. Make informed decisions about your health.",
        cta: true,
        icon: "Heart"
      }
    ]
  },
  {
    id: 20,
    title: "Know Your Blood Pressure Numbers",
    slug: "know-your-blood-pressure-numbers",
    excerpt: "Understanding the new blood pressure standards could save your life. Learn where you fall and what actions to take.",
    category: "Heart Health",
    topicCategory: "Adult Health",
    readTime: "8 min",
    date: "2026-02-06",
    image: "https://images.unsplash.com/photo-1559757175-5700dde675bc?w=800",
    author: "CADENCE Medical Team",
    isSlideshow: true,
    slides: [
      {
        title: "The Standards Changed",
        content: "What was considered 'normal' blood pressure has been updated—and understanding these new standards could save your life.",
        columns: [
          {
            header: "Old Standard (JNC8)",
            items: ["High BP was 140/90 mmHg", "Many people were told they were 'fine'", "Earlier intervention was missed"]
          },
          {
            header: "New Standard (ACC/AHA)",
            items: ["High BP is now 130/80 mmHg", "Earlier intervention prevents damage", "More proactive approach to heart health"]
          }
        ],
        highlight: "The goalposts moved to prevent heart and kidney damage earlier.",
        icon: "AlertTriangle"
      },
      {
        title: "Your Blood Pressure Categories",
        content: "Understanding where you fall helps guide your treatment plan:",
        cards: [
          { title: "Normal", stat: "<120/80", desc: "Keep up the good work!" },
          { title: "Elevated", stat: "120-129/<80", desc: "Time for lifestyle changes" },
          { title: "Stage 1 High", stat: "130-139/80-89", desc: "Action needed now" },
          { title: "Stage 2 High", stat: "140+/90+", desc: "Medication likely needed" }
        ],
        highlight: "Crisis Level: Over 180/120 requires immediate emergency care.",
        icon: "Activity"
      },
      {
        title: "Is Your Diagnosis Hard to Accept?",
        content: "Many people struggle with denial, confusion, or disbelief when first diagnosed. Your feelings are completely normal.",
        bullets: [
          "\"I don't understand why this is happening to me...\"",
          "\"It doesn't make sense that my numbers are high...\"",
          "\"I have trouble believing this diagnosis...\""
        ],
        highlight: "CADENCE asks: \"Is there anything about your current diagnosis you find hard to accept or understand?\"",
        icon: "Heart"
      },
      {
        title: "Special Considerations: Age Matters",
        content: "For adults over 50, the below 130/80 goal is crucial.",
        bullets: [
          "Blood vessels naturally stiffen with age",
          "Controlling pressure prevents strokes",
          "Reduces risk of heart failure",
          "Protects memory and cognitive function"
        ],
        highlight: "Earlier intervention helps maintain quality of life as you age.",
        icon: "Clock"
      },
      {
        title: "Special Considerations: Pregnancy History",
        content: "Women with preeclampsia history face significantly higher future risk:",
        cards: [
          { title: "7x Higher", stat: "7x", desc: "More likely to develop chronic hypertension", showPie: false },
          { title: "40%", stat: "40%", desc: "Develop hypertension within 3 years of delivery", showPie: true, pieColor: "#E11D48" }
        ],
        highlight: "Action Step: Annual blood pressure checks for life are essential, even if pressure normalized after birth.",
        icon: "Shield"
      },
      {
        title: "Lifestyle Changes That Work",
        content: "These modifications are foundational and can be as effective as medication:",
        barChart: [
          { label: "DASH Diet", value: 82 },
          { label: "Lose Weight (per 10kg)", value: 75 },
          { label: "Get Active (30 min/day)", value: 65 },
          { label: "Cut Sodium (<2,300mg)", value: 50 },
          { label: "Limit Alcohol", value: 30 }
        ],
        barChartMax: 100,
        icon: "TrendingUp"
      },
      {
        title: "Common Barriers & Solutions",
        content: "What gets in your way? CADENCE helps you overcome these challenges:",
        columns: [
          {
            header: "Common Barriers",
            items: ["Maintaining the diet", "Finding time to exercise", "Staying consistent", "Understanding choices"]
          },
          {
            header: "CADENCE Helps",
            items: ["Set realistic goals", "Personalized strategies", "Ongoing support", "Clear explanations"]
          }
        ],
        highlight: "\"What makes it difficult for you to follow your treatment plan?\"",
        icon: "Target"
      },
      {
        title: "Your Action Plan",
        content: "Four key steps to taking control of your blood pressure:",
        cards: [
          { title: "Know Your Goal", stat: "<130/80", desc: "Aim for blood pressure under 130/80" },
          { title: "Know Your Risk", stat: "History", desc: "Age and pregnancy history matter" },
          { title: "Lifestyle Medicine", stat: "Daily", desc: "Diet, exercise, weight management" },
          { title: "Get Support", stat: "CADENCE", desc: "Understand diagnosis, overcome barriers" }
        ],
        highlight: "If lifestyle changes aren't enough, medication may be needed. Benefits far outweigh risks for most people.",
        cta: true,
        icon: "CheckCircle"
      }
    ]
  },
  {
    id: 21,
    title: "Blood Pressure Medications: How They Work and Who They Help",
    slug: "blood-pressure-medications",
    excerpt: "Your guide to understanding the four major medication classes, how they work, and finding the right fit for your health profile.",
    category: "Heart Health",
    topicCategory: "Adult Health",
    readTime: "10 min",
    date: "2026-02-06",
    image: "https://customer-assets.emergentagent.com/job_cadence-consult/artifacts/t6l926fk_Screenshot_20260206_010243_Chrome.jpg",
    author: "CADENCE Medical Team",
    content: `## Blood Pressure Medications: How They Work and Who They Help

Understanding your blood pressure medication options helps you work more effectively with your healthcare team. Here's what you need to know about the four major medication classes.

### Four Major Medication Classes

Doctors choose from these evidence-based options based on your health profile:

**1. Diuretics**
- **How They Work:** Help kidneys remove sodium and water
- **What to Know:** Strong response across all patients, often a top first choice
- **Side Effects:** May cause frequent urination initially

**2. Calcium Channel Blockers (CCBs)**
- **How They Work:** Relax and widen blood vessels
- **Common Names:** Amlodipine, Diltiazem
- **Key Benefit:** Highly effective for all patients with average reductions of 15-17 mmHg systolic
- **Side Effects:** Swollen ankles, headache, dizziness

**3. ACE Inhibitors & ARBs**
- **How They Work:** Block hormones that cause blood vessels to tighten
- **Clinical Note:** Often paired with diuretics for optimal results
- **Side Effects:** ACE inhibitors may cause dry cough

**4. Beta-Blockers**
- **How They Work:** Slow heart rate, reduce workload
- **Common Names:** Metoprolol, Atenolol
- **Best Use:** Often combined with other medications rather than used alone
- **Side Effects:** Fatigue, cold hands or feet

### Comparing Medication Effectiveness

Average blood pressure reductions vary by medication class:
- **Diuretics:** Highly effective across all populations
- **Calcium Channel Blockers:** 15-17 mmHg average reduction
- **ACE/ARBs:** Effective, especially when combined with diuretics
- **Beta-Blockers:** Moderately effective, often used in combination

### Overcoming Medication Barriers

Taking medication consistently is key to success. Common barriers are normal and worth discussing openly:

1. **Identify:** What makes following your plan difficult?
2. **Discuss:** Share concerns about side effects or cost
3. **Solve:** Work with your doctor on practical solutions

### Clinical Guidelines

- Most patients benefit from starting with a CCB or thiazide diuretic
- Combination therapy with 2+ medications is common and effective
- The best medication is one that safely lowers your blood pressure
- Benefits far outweigh potential risks for most people

### CADENCE Support

We help facilitate partnership with your doctor through clear data and communication support. Have questions? Your healthcare team is here to help you find the right treatment plan.`
  },
  {
    id: 106,
    title: "The Hidden Story in Your Chart That No One Has Time to Read",
    subtitle: "Your medical record contains a narrative\u2014but it\u2019s written in fragments across years of visits. Here\u2019s why finding the story matters.",
    excerpt: "Your medical record tells a story scattered across years. Labs here, imaging there, a consult note from three years ago. The story exists\u2014but no one has time to read it.",
    category: "Medical Records",
    topicCategory: "Record Review",
    readTime: "8 min",
    image: "https://images.unsplash.com/photo-1578016981482-d4dd3db297b1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwxfHxtZWRpY2FsJTIwcmVjb3JkcyUyMGRvY3VtZW50cyUyMGhlYWx0aGNhcmUlMjBjaGFydCUyMHJldmlld3xlbnwwfHx8fDE3NzY0MjQzMTN8MA&ixlib=rb-4.1.0&q=85",
    date: "2026-04-13",
    author: "Lakia S. Stewart, DNP, FNP-C, WHNP-BC",
    authorRole: "Chief Medical Officer, CADENCE Medical Consulting, LLC",
    featured: false,
    isSlideshow: true,
    slides: [
      {
        title: "Every Patient Has a Story",
        content: "It\u2019s the story of when the fatigue started. Of the medication that helped for a while, then didn\u2019t. Of the symptom that came and went, dismissed as stress. Of the specialist who ordered a test and never followed up.",
        highlight: "The problem is, that story is never written down in one place.",
        icon: "BookOpen"
      },
      {
        title: "Scattered Across Systems",
        content: "Your story exists\u2014but it\u2019s fragmented across years of visits, multiple health systems, and dozens of documents.",
        bullets: [
          "Lab results at one facility",
          "Imaging at another",
          "A consult note from three years ago",
          "A discharge summary from an ER visit you barely remember",
          "Medications documented differently by each provider"
        ],
        highlight: "The story exists. But no one has time to read it.",
        icon: "FileText"
      },
      {
        title: "Why the Full Story Matters",
        content: "In military medicine, we learned a principle: you don\u2019t make decisions based on partial intelligence. You gather everything. You look for patterns. You verify before you act.",
        highlight: "Healthcare should work the same way. But it rarely does.",
        icon: "Shield"
      },
      {
        title: "The Hidden Diagnosis",
        content: "A patient comes in with fatigue. The most recent labs are checked. They\u2019re normal. The visit ends. But buried in the record is a completely different picture:",
        bullets: [
          "A slow decline in iron stores over two years",
          "A medication change that coincided with symptom onset",
          "A specialist note mentioning \u2018possible autoimmune component\u2019"
        ],
        highlight: "Individually, none of those pieces triggers action. Together, they point toward a different diagnosis entirely.",
        icon: "Search"
      },
      {
        title: "What Gets Lost \u2014 Temporal Patterns",
        content: "When did the symptom start? What changed around that time? A new medication? A life stressor? A different diagnosis?",
        bullets: [
          "Connections require looking across time, not just at the most recent snapshot",
          "A symptom that began six months after a medication change may not seem related\u2014unless you map it",
          "Life events, surgeries, and stressors create invisible timelines that matter"
        ],
        icon: "Clock"
      },
      {
        title: "What Gets Lost \u2014 Contradictions",
        content: "Without a unified view, critical contradictions go unnoticed across your records:",
        bullets: [
          "One provider documents a medication; another documents a different dose",
          "A lab result conflicts with a prior trend",
          "Allergies listed inconsistently across systems",
          "Diagnoses that appear and disappear without explanation"
        ],
        highlight: "No single provider sees the full picture\u2014and they rarely compare notes.",
        icon: "AlertTriangle"
      },
      {
        title: "What Gets Lost \u2014 Silent Progression",
        content: "Many conditions worsen slowly. A single data point looks fine. The trend tells the real story.",
        cards: [
          { title: "Blood Pressure", stat: "Creeping Up", desc: "Gradual rise missed in isolated visits" },
          { title: "Kidney Function", stat: "Drifting Down", desc: "Slow decline invisible without trend analysis" },
          { title: "Iron Stores", stat: "Depleting", desc: "Two-year pattern hidden in separate lab reports" }
        ],
        icon: "TrendingUp"
      },
      {
        title: "Step 1: Request Your Records",
        content: "You don\u2019t need a medical degree to begin reclaiming your narrative.",
        bullets: [
          "Request your full medical records from every provider you\u2019ve seen in the last 3\u20135 years",
          "You have a legal right to them under HIPAA",
          "Include labs, imaging, visit notes, discharge summaries, and specialist consults",
          "Don\u2019t forget urgent care and ER visits"
        ],
        icon: "Download"
      },
      {
        title: "Step 2: Organize & Step 3: Find the Edges",
        content: "Put your records in chronological order. Labs together. Imaging together. Visit notes together. Then look for the edges\u2014the places where something changed.",
        bullets: [
          "A new symptom appeared",
          "A medication was adjusted",
          "A referral to a new specialist was made",
          "A test result shifted from the previous baseline"
        ],
        highlight: "Those edges are where the story lives.",
        icon: "Clipboard"
      },
      {
        title: "You Deserve to Know the Full Story",
        content: "Your health journey is not a series of disconnected transactions. It\u2019s a continuous narrative. And you deserve to have it read by someone with the training, the time, and the commitment to find what others missed.",
        highlight: "At CADENCE, we don\u2019t skim. We read the whole story. Then we hand it back to you\u2014clear, connected, and ready for the next chapter.",
        bullets: [
          "Your records hold answers",
          "Your timeline reveals patterns",
          "Your story deserves to be heard"
        ],
        cta: true,
        icon: "Heart"
      }
    ]
  },
  {
    id: 107,
    title: "Another Specialist Won\u2019t Fix Your Complex Health Issue. Someone Reading the Whole Record Will.",
    subtitle: "The counterintuitive truth about second opinions that could change how you think about your health journey.",
    excerpt: "You\u2019ve seen the rheumatologist, the endocrinologist, the cardiologist. Each one brilliant. Each one focused on their piece. But you\u2019re still without answers. What if the solution isn\u2019t another specialist?",
    category: "Patient Advocacy",
    topicCategory: "Second Opinions",
    readTime: "10 min",
    image: "https://images.unsplash.com/photo-1576091160550-2173dba999ef?w=800",
    date: "2026-04-20",
    author: "Lakia S. Stewart, DNP, FNP-C, WHNP-BC",
    authorRole: "Chief Medical Officer, CADENCE Medical Consulting, LLC",
    featured: false,
    isSlideshow: true,
    slides: [
      {
        title: "The Advice You\u2019ve Heard a Hundred Times",
        content: "If you\u2019ve been dealing with a complex health issue, you\u2019ve probably heard this advice a hundred times: \u201CYou should see a specialist.\u201D Maybe you\u2019ve seen several. A rheumatologist. An endocrinologist. A cardiologist.",
        highlight: "Each one brilliant. Each one focused on their piece of the puzzle.",
        icon: "Stethoscope"
      },
      {
        title: "The Unspoken Frustration",
        content: "But here\u2019s what no one tells you. After the third, fourth, fifth specialist, you have more information than ever\u2014and less clarity.",
        bullets: [
          "More reports",
          "More \u201Cnormal\u201D labs",
          "More recommendations that don\u2019t quite fit together",
          "You\u2019re not closer to an answer"
        ],
        highlight: "You\u2019re just more confused, more exhausted, and more convinced something is being missed.",
        icon: "AlertTriangle"
      },
      {
        title: "The Counterintuitive Truth",
        content: "Here\u2019s the truth most people don\u2019t want to admit: in complex cases, adding another specialist doesn\u2019t solve the problem. It often makes it worse.",
        highlight: "What\u2019s missing isn\u2019t more specialized expertise. What\u2019s missing is someone who will forensically analyze your records at a depth no typical appointment allows.",
        icon: "BookOpen"
      },
      {
        title: "Page 47",
        content: "I recently reviewed a patient\u2019s records\u2014over 300 pages from six different providers. Buried on page 47 was a lab value flagged as \u201Cmildly abnormal\u201D two years ago.",
        bullets: [
          "The specialist noted it and moved on",
          "The primary care provider never saw it",
          "The patient certainly didn\u2019t know",
          "Two years later, that same value had drifted further"
        ],
        highlight: "The clue was there all along. It just needed someone to forensically analyze the whole record\u2014not just skim the latest chapter.",
        icon: "Search"
      },
      {
        title: "The Evidence",
        content: "This isn\u2019t just one story. The research is clear.",
        cards: [
          { title: "Diagnoses Revised", stat: "30%", desc: "of initial diagnoses revised on record review alone\u2014no new tests" },
          { title: "New Diagnosis", stat: "88%", desc: "of second-opinion patients received a new or refined diagnosis (Mayo Clinic, 2017)" },
          { title: "Completely Changed", stat: "21%", desc: "of cases where the diagnosis changed entirely from re-reading existing data" }
        ],
        icon: "BarChart"
      },
      {
        title: "Why More Specialists Can Make It Worse",
        content: "Every new specialist creates another silo. Another set of notes that may never reach the others. Another fragment of a story no one is assembling.",
        bullets: [
          "Records spread across 4+ health systems with no unified view",
          "Each provider sees their slice\u2014no one reads the full timeline",
          "Contradictions between providers go unnoticed",
          "Adding more data to a fragmented picture rarely clarifies it"
        ],
        highlight: "Someone must synthesize what\u2019s already there.",
        icon: "Layers"
      },
      {
        title: "The Moment Everything Shifts",
        content: "Imagine being at dinner. Someone mentions they\u2019re on their fourth specialist for unexplained fatigue. You say:",
        highlight: "\u201CThe answer might already be in your records. The most valuable second opinion I ever saw came from someone who never even examined the patient\u2014they just read three years of labs and found the trend everyone missed.\u201D",
        bullets: [
          "The table goes quiet",
          "Someone asks, \u201CWait\u2014how is that possible?\u201D",
          "That\u2019s the moment everything shifts"
        ],
        icon: "MessageCircle"
      },
      {
        title: "Not Another Opinion. The Full Story.",
        content: "That\u2019s why we built CADENCE. Not to add another specialist to your list. But to forensically analyze your entire medical record\u2014at a depth no typical healthcare appointment will ever allow.",
        bullets: [
          "We medically translate and synthesize what appear to be random, disconnected data points",
          "Every specialist note cross-referenced against your full timeline",
          "Every medication change mapped to symptom onset",
          "A clear, written report\u2014in plain language\u2014you can take to any provider"
        ],
        highlight: "We don\u2019t give you another opinion. We give you clarity.",
        cta: true,
        icon: "Shield"
      },
      {
        title: "The CADENCE Promise",
        content: "Another specialist won\u2019t fix your complex health issue. Someone reading the whole record will.",
        highlight: "Your records already hold the story. You just need someone who will actually read\u00A0it.",
        cta: true,
        icon: "Heart"
      }
    ]
  },
  {
    id: 108,
    title: "The Missing Diagnosis and the Impossible Math",
    subtitle: "Every patient has a story. The problem is, that story is never written down in one place. Here\u2019s how hidden clues get missed\u2014and how to find them.",
    excerpt: "There\u2019s the story of when the fatigue started. The medication that helped, then didn\u2019t. The symptom dismissed as stress. That story is scattered across years of visits and dozens of documents. And no one has time to read it.",
    category: "Medical Records",
    topicCategory: "Record Review",
    readTime: "9 min",
    image: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=1200&q=80",
    date: "2026-04-20",
    author: "Lakia S. Stewart, DNP, FNP-C, WHNP-BC",
    authorRole: "Chief Medical Officer, CADENCE Medical Consulting, LLC",
    featured: false,
    isSlideshow: true,
    slides: [
      {
        title: "Every Patient Has a Story",
        content: "There\u2019s the story of when the fatigue started. The story of the medication that helped for a while, then didn\u2019t. The story of the symptom that came and went, and was dismissed as stress. The story of the specialist who ordered a test and never followed\u00A0up.",
        highlight: "The problem is, that story is never written down in one\u00A0place.",
        icon: "BookOpen"
      },
      {
        title: "Scattered Across Systems",
        content: "That story is fragmented across years of visits, multiple health systems, and dozens of\u00A0documents.",
        bullets: [
          "Labs here",
          "Imaging there",
          "A consult note from three years ago",
          "A discharge summary from an ER visit they barely remember"
        ],
        highlight: "The story exists. But no one has time to read\u00A0it.",
        icon: "FileText"
      },
      {
        title: "The Hidden Diagnosis",
        content: "Today that same patient goes to primary care with concerns about extreme fatigue. The most recent labs are checked. The labs that are ordered are normal. The visit\u00A0ends.",
        bullets: [
          "Buried in the record: a slow decline in iron stores over two years",
          "A medication change that coincided with the onset of symptoms",
          "A specialist note mentioning \u201Cpossible autoimmune component\u201D"
        ],
        highlight: "Individually, none of those pieces triggers action. Together, they point toward a different diagnosis entirely.",
        icon: "Search"
      },
      {
        title: "Hiding in Plain Sight",
        content: "This is the hidden story. And it\u2019s hiding in plain sight. The clues aren\u2019t missing\u2014they\u2019re buried across hundreds of pages that no one has time to synthesize.",
        highlight: "A typical patient with a few chronic conditions generates hundreds of pages of records. In a standard 12-minute visit, there is simply no time to read the full\u00A0story.",
        icon: "Clock"
      },
      {
        title: "The Lab That Was \u201CSlightly Off\u201D",
        content: "Lab reports are designed for speed. Abnormal values are flagged. Normal values fade into the background. But there\u2019s a dangerous gray zone: the value that\u2019s technically within range but trending in the wrong direction.",
        bullets: [
          "Ask for a trend report, not just the latest results",
          "Look for values that are moving\u2014even within the \u201Cnormal\u201D range",
          "A steady decline over years is a story worth reading",
          "Don\u2019t accept \u201Cnormal\u201D at face value\u2014ask \u201Cnormal compared to when?\u201D"
        ],
        icon: "TrendingDown"
      },
      {
        title: "The Radiologist\u2019s Full Impression",
        content: "When you get an MRI or CT, you hear \u201Ceverything looks fine.\u201D But radiologists are precise writers. Buried in the report, you might\u00A0find:",
        bullets: [
          "\u201CMild heterogeneity noted\u201D",
          "\u201CSubtle asymmetry compared to prior study\u201D",
          "\u201CNonspecific finding of uncertain clinical significance\u201D"
        ],
        highlight: "These are not red alerts. They are breadcrumbs. And when a clinician is moving fast, the breadcrumb gets left\u00A0behind.",
        icon: "FileText"
      },
      {
        title: "The Note That Never Made It",
        content: "You assume your doctors talk to each other. Sometimes they do. Often, they\u00A0don\u2019t.",
        bullets: [
          "A cardiologist adjusts your blood pressure medication",
          "An endocrinologist tweaks your thyroid dose",
          "A rheumatologist starts a new anti-inflammatory",
          "Each one documents the change in their own system"
        ],
        highlight: "Unless someone actively sends that note across health systems, your primary care provider may never see\u00A0it.",
        icon: "AlertTriangle"
      },
      {
        title: "When No One Has the Full Picture",
        content: "The clues were there, scattered across three different portals. Three medications working against each other because no single provider had the full\u00A0list.",
        highlight: "No one was wrong. Everyone was just looking at their own\u00A0chapter.",
        cards: [
          { title: "System A", stat: "Cardiologist", desc: "Changed BP medication\u2014noted in their portal only" },
          { title: "System B", stat: "Endocrinologist", desc: "Adjusted thyroid dose\u2014PCP never notified" },
          { title: "System C", stat: "Rheumatologist", desc: "New anti-inflammatory\u2014interacts with System A" }
        ],
        icon: "Layers"
      },
      {
        title: "The Impossible Math",
        content: "None of this is about blaming clinicians. They\u2019re working in a system that rewards speed and undervalues synthesis.",
        highlight: "The math is impossible: hundreds of pages, twelve minutes. Until that system changes, the responsibility to connect the dots falls on you\u2014or on someone you trust to do it for\u00A0you.",
        icon: "Heart"
      },
      {
        title: "We Find What Gets Missed",
        content: "At CADENCE, we forensically analyze your entire medical record\u2014at a depth no typical healthcare appointment will ever allow. We medically translate and synthesize what appear to be random, disconnected data points into one clear\u00A0narrative.",
        highlight: "Your story is in those records. You just need someone who will actually read\u00A0it.",
        cta: true,
        icon: "Shield"
      }
    ]
  },
  {
    id: 22,
    title: 'The Story of the Missing Diagnosis and the Impossible Math',
    excerpt: 'Every patient has a story. It\u2019s just never written down in one place. Here\u2019s how the fragmented system hides diagnoses in plain sight\u2014and what you can do about it.',
    category: 'Patient Advocacy',
    topicCategory: 'Record Review',
    readTime: '10 min',
    image: 'https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=1200&q=80',
    date: '2026-04-20',
    author: 'Lakia S. Stewart, DNP, FNP-C, WHNP-BC',
    authorRole: 'Chief Medical Officer, CADENCE Medical Consulting, LLC',
    content: `**Every patient has a story.**

It\u2019s the story of when the symptoms first began\u2014the fatigue that crept in and never left, the GI distress that came and went without explanation, the brain fog that made ordinary tasks feel impossible, the pain that migrated from joint to joint with no clear pattern. It\u2019s the chapter about the medication that worked for a while, then didn\u2019t. The footnote about the symptom that was dismissed as stress. The subplot of the specialist who ordered a test and never circled back.

**That story exists. It\u2019s just never written down in one place.**

Instead, it\u2019s fragmented across years of visits, multiple providers, and different health systems. Labs from three years ago. Imaging from an ER visit barely remembered. A consult note from a specialist whose name is now a blur. A discharge summary that lists a medication change no one ever mentioned again. The pieces are all there. Scattered.

A patient arrives with a complaint\u2014maybe fatigue, maybe unexplained GI issues, maybe a constellation of symptoms that don\u2019t fit neatly into a single specialty. The most recent labs are checked. They\u2019re within the reference range. The visit ends in twelve minutes.

But buried in the record is a slow decline in iron stores over two years. A medication adjustment that coincided with the onset of symptoms. A specialist note from eighteen months ago mentioning \u201Cpossible autoimmune component.\u201D Individually, none of those fragments triggers action. Together, they point toward an entirely different understanding of what\u2019s happening.

**This is the impossible math of modern healthcare.**

A single patient with a few chronic conditions and a handful of specialists can easily generate hundreds of pages of medical records. In a standard 12-minute appointment, there is simply no time to read across visits and connect the dots. So clinicians do what anyone would do: they check the most recent labs, glance at the last specialist\u2019s note, and rely on the patient to fill in the gaps. The deeper story\u2014the one buried in a lab trend from two years ago, or in a radiologist\u2019s full impression, or in a medication change that never made it to the primary care provider\u2014remains unread.

Here are three places where the missing story often hides.

---

**The Lab Trend That Drifted Over Years**

Lab reports are designed for speed. Abnormal values are flagged in bold or red. Normal values fade into the background. But there\u2019s a dangerous gray zone: the value that\u2019s technically within the reference range but trending in the wrong direction. A patient\u2019s kidney function drifts downward over four years. Every individual lab is \u201Cnormal.\u201D No flags. No alerts. But lined up chronologically, the slope is unmistakable. Something is changing\u2014slowly, quietly, invisibly to anyone only looking at the most recent page.

---

**The Radiologist\u2019s Full Impression (Not Just the Summary Line)**

An MRI or CT scan comes back. The patient hears \u201Ceverything looks fine.\u201D But radiologists are precise writers. Buried in the body of the report are phrases like \u201Cmild heterogeneity noted,\u201D \u201Csubtle asymmetry compared to prior study,\u201D or \u201Cnonspecific finding of uncertain clinical significance.\u201D These are not red alerts. They are breadcrumbs. And when a clinician is moving fast, they may read only the \u201CImpression\u201D section at the bottom. The nuance\u2014the breadcrumb\u2014gets left behind.

---

**The Specialist\u2019s Note That Never Made It to the Primary Care Provider**

A cardiologist adjusts a blood pressure medication. An endocrinologist tweaks a thyroid dose. A rheumatologist starts a new anti-inflammatory. Each one documents the change in their own system. But unless someone actively sends that note across health systems\u2014or unless the patient brings a printed copy to the next appointment\u2014the primary care provider may never see it. Records have been reviewed where a patient was on three medications working against each other because no single provider had the full list. The clues were there, scattered across different portals.

---

None of this is about blaming clinicians. They work in a system that rewards speed and undervalues synthesis. But until that system changes, the responsibility to connect the dots across visits and providers falls on the patient\u2014or on someone hired to do it for them.

**The missing diagnosis doesn\u2019t have to stay missing. It just needs someone trained to translate what the system leaves unread.**

At CADENCE, we analyze a cross-section of records across multiple visits and multiple providers\u2014enough to see the patterns, the contradictions, and the threads that got dropped. We decipher what the system only skims. Then we hand back a clear, written plan so patients can finally move forward with confidence.`
  }
];

export const testimonials = [
  {
    id: 1,
    name: 'Sarah M.',
    role: 'Army Veteran',
    content: 'After years of being told my symptoms were "just stress," CADENCE helped me get the thorough thyroid testing I needed. They gave me the script to advocate for myself, and I finally have answers.',
    rating: 5
  },
  {
    id: 2,
    name: 'Jennifer L.',
    role: 'Lupus Patient',
    content: 'The deep dive consultation changed everything. They reviewed all my lab work, explained what each test meant, and prepared me for my rheumatology appointment. I felt empowered and heard for the first time.',
    rating: 5
  },
  {
    id: 3,
    name: 'Maria G.',
    role: 'Monthly Member',
    content: 'Having a medical consultant on retainer has been life-changing. I can message them anytime with concerns, and they help me know when something needs immediate attention versus when I can wait.',
    rating: 5
  }
];

export const faqData = [
  {
    question: 'What is CADENCE Medical Consulting, LLC?',
    answer: 'CADENCE Medical Consulting, LLC provides remote tele-second opinion care and medical advocacy services. We specialize in reviewing diagnostic materials, interpreting lab results, and helping patients advocate effectively with their healthcare providers. We focus on hard-to-diagnose conditions, women\'s health, and veterans care.'
  },
  {
    question: 'Are you replacing my doctor?',
    answer: 'No, we complement your existing healthcare team. We provide expert review, interpretation, and advocacy support to help you have more productive conversations with your doctors and get the care you deserve. We help you understand your results and prepare questions to ask your providers.'
  },
  {
    question: 'What conditions do you specialize in?',
    answer: 'We specialize in hard-to-diagnose autoimmune conditions (lupus, Hashimoto\'s, rheumatoid arthritis), thyroid disorders, women\'s health issues, and healthcare navigation for veterans. We\'re experienced in cases where patients have been dismissed or struggle to get clear answers.'
  },
  {
    question: 'How does the consultation process work?',
    answer: 'After booking, you\'ll submit your medical records and lab results. We review everything thoroughly before your scheduled consultation. During the consultation, we discuss your results, answer your questions, and create a personalized medical script for your next doctor visit. You\'ll receive a written summary afterward.'
  },
  {
    question: 'What is a "medical script"?',
    answer: 'A medical script is a personalized guide we create that outlines exactly what to say to your doctor, what questions to ask, and what tests or treatments to request. It empowers you to advocate effectively for yourself during medical appointments.'
  },
  {
    question: 'Do you accept insurance?',
    answer: 'We are a private consulting service and do not bill insurance directly. However, we can provide documentation that you may be able to submit to your insurance for possible reimbursement under out-of-network benefits. HSA/FSA funds can typically be used for our services.'
  },
  {
    question: 'What\'s included in the membership plans?',
    answer: 'Monthly members get unlimited messaging access, priority responses, a monthly consultation, and discounts on additional services. Quarterly members receive all monthly benefits plus a deep dive consultation each quarter, higher discounts, and family member consultations. It\'s like having a medical consultant on retainer.'
  },
  {
    question: 'How does the affiliate program work?',
    answer: 'Our affiliate program offers 10% commission on all paid services from your referrals. When someone you refer becomes a paying client, you earn commission on their initial purchase and any future services they book. It\'s our way of thanking you for helping others access quality medical advocacy.'
  }
];